import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Claude: alpha-tester feedback — "Interface language resets. Select French, then refresh the page:
// Claude: English returns." The navbars already saved the choice to localStorage("taal"), but nothing
// Claude: ever read it back. Only a code this file actually has a catalogue for is accepted, so a
// Claude: stale/garbage value can't leave i18next on a language with no strings. Wrapped in try/catch
// Claude: since localStorage access can throw (private windows, blocked site data).
const SUPPORTED_INTERFACE_LANGUAGES = ["en", "af", "zu", "st", "nso", "tn", "ts", "ss", "nr", "xh", "ve", "pt", "fr"];
export function getSavedInterfaceLanguage() {
  try {
    const saved = localStorage.getItem("taal");
    return SUPPORTED_INTERFACE_LANGUAGES.includes(saved) ? saved : null;
  } catch (e) {
    return null;
  }
}

i18n.use(initReactI18next).init({
  // Claude: was true — alpha testers flagged the console full of i18next debug output on the live site.
  debug: false,
  lng: getSavedInterfaceLanguage() || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        word: "Term",
        update_term: "Update term",
        source: "Source language",
        target: "Target language",
        partial: "Partial match",
        fuzzy: "Allow for spelling mistakes",
        enter: "Enter search term",
        terminology: "Terminology Hub",
        alllanguages: "All languages",
        allstatus: "Any status",
        search: "Search",
        language: "Language",
        context: "Context",
        add: "Add a new term",
        advanced: "Advanced search",
        accepted: "Accepted",
        pending: "Pending",
        rejected: "Rejected",
        flagged: "Flagged",
        ACC: "Accepted",
        PND: "Pending",
        REJ: "Rejected",
        FLG: "Flagged",
        status: "Status",
        translate_term: "Translate term",
        sourceword: "Source term",
        translatedterm: "Translated term",
        example: "Example",
        attribution: "Attribution",
        newlanguage: "New language",
        definition: "Definition",
        school: "School",
        about: "About us",
        contact: "Contact us",
        user_manual: "User manual",
        addterm: "Add term",
        termdetail: "Term detail",
        deleteconfirma: "Are you sure you want to delete '",
        deleteconfirmb: "' with context '",
        deleteconfirmc: "' in language '",
        deleteconfirmd: "'?",
        yes: "Yes",
        no: "No",
        back: "Back",
        translate: "Translate",
        update: "Update",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        login: "Log in",
        logout: "Log out",
        // Claude: alpha-tester feedback — "please check that all messages are using i18n" — a
        // batch of previously hardcoded validation/error strings found across the app.
        validation_word_required: "A word is required.",
        validation_translation_required: "A translated term is required.",
        something_went_wrong: "Something went wrong.",
        english_translation: "English translation:",
        search_term_required: "Search term is required.",
        login_failed: "Login failed!",
        generic_error: "An error occurred",
        could_not_download_template: "Could not download the template.",
        could_not_download_file: "Could not download the file.",
        could_not_run_report: "Could not run the report.",
        could_not_delete_request: "Could not delete the request.",
        search_failed: "Search failed.",
        delete_failed: "Delete failed.",
        something_went_wrong_adding_term: "Something went wrong while adding the term.",
        failed_to_add_term: "Failed to add the term.",
        something_went_wrong_fetching_terms: "Something went wrong while fetching terms.",
        registration_failed: "Registration failed",
        confirmlogout: "Confirm log out",
        register: "Register user",
        emailaddress: "Email address",
        typeagain: "Type email address again",
        surname: "Surname",
        firstname: "First name",
        username: "User name",
        password: "Password",
        message_username: "Username already exists. Please choose another.",
        message_email: "Email already registered. Please use another email.",
        message_valid: "The email address is not valid.",
        message_notsame: "The email addresses are not the same.",
        request_translation: "Request translation",
        submit_request: "Submit request",
        term_not_found: "Term not found",
        submitsuccess: "Request submitted successfully!",
        theterm: "The term ",
        notfound: " was not found.",
        liketorequest: "Would you like to request a translation? ",
        suggest_translationa: "Do you want to suggest a possible term in ",
        suggest_translationb: "?",
        ifsotype: "If so, type it here:",
        notranslation: "No translation was found.",
        add_request: "Add requested term",
        add_translation: "Add translation",
        delete_request: "Delete request",
        delete_request_confirm: "Delete this request? This cannot be undone.",
        suggested_translation: "Suggested translation",
        date_requested: "Date requested",
        action: "Action",
        no_requests: "No requests found",
        r_user: "Registered user",
        editor: "Editor",
        date_edited_label: "Last edited:",
        delete_a: "Delete A",
        delete_b: "Delete B",
        delete_word_confirm: "Delete '{{word}}'? This cannot be undone.",
        administrator: "Administrator",
        requestlist: "Requested terms",
        word_to_be_added: "Term to be added",
        pos: "Part of speech",
        unknown: "Unknown",
        noun: "Noun",
        verb: "Verb",
        adjective: "Adjective",
        pronoun: "Pronoun",
        adverb: "Adverb",
        preposition: "Preposition",
        conjunction: "Conjunction",
        interjection: "Interjection",
        article: "Article",
        suggests: "suggests",
        wiktionary_lookup: "Look up on Wiktionary",
        actions: "Actions",
        review_queue: "Review queue",
        my_suggestions: "My suggestions",
        missing_terms: "Missing terms",
        duplicate_cleanup: "Duplicate cleanup",
        english: "English",
        submitted_by: "Submitted by",
        days_pending: "Days pending",
        approve: "Approve",
        reject: "Reject",
        flag_action: "Flag",
        previous: "Previous",
        next: "Next",
        nothing_waiting_review: "Nothing is waiting for review.",
        showing_range: "Showing {{start}}–{{end}} of {{total}}",
        you_havent_submitted: "You haven't submitted any terms yet.",
        target_language: "Target language:",
        nothing_missing: "Nothing is missing for this language.",
        match_type: "Match",
        word_a: "Word A",
        word_b: "Word B",
        english_reference_label: "English (for reference only)",
        no_english_reference: "No English reference entry found.",
        user_admin: "User Administration",
        approver: "Approver",
        role: "Role",
        change_role: "Change role",
        download_csv_template: "Download CSV template",
        upload_csv: "Upload CSV",
        uploading: "Uploading...",
        upload_progress: "{{completed}} / {{total}} term(s) processed",
        upload_interrupted: "Upload interrupted after {{completed}} of {{total}} term(s). Please check the results and re-upload the remaining rows if needed.",
        choose_csv_file: "Choose CSV file",
        bulk_upload_users: "Bulk upload users",
        bulk_upload_help: "Upload a CSV file to create multiple users at once. Download the template below first to make sure the file is in the right format.",
        temporary_password: "Temporary password",
        temporary_password_notice: "Copy this password now and share it with the user — it will not be shown again.",
        user_created: "User '{{username}}' created.",
        delete_user_confirm: "Delete user '{{username}}'? This cannot be undone.",
        csv_upload_results: "Upload results",
        rows_created: "{{count}} user(s) created",
        terms_created: "{{count}} term(s) added",
        duplicate_warning_title: "Possible duplicate import",
        duplicate_warning_message: "All {{count}} term(s) in this file already exist. This looks like the same list being imported again.",
        replace_previous_import: "Replace previous import",
        add_in_any_case: "Add in any case",
        rows_skipped: "{{count}} row(s) skipped",
        row_label: "Row",
        error_label: "Error",
        existing_users: "Existing users",
        term_admin: "Term Administration",
        bulk_upload_terms: "Bulk upload terms",
        bulk_upload_terms_help: "Upload a CSV file to create multiple terms at once, for example from a list prepared elsewhere. Download the template below first to make sure the file is in the right format.",
        export_terms: "Export terms",
        search_export_terms: "Search / export terms",
        export_terms_help: "Filter the terms below, then search to see what matches, export them to CSV, or delete them in bulk.",
        export_csv: "Export CSV",
        exporting: "Exporting...",
        search_terms: "Search",
        searching: "Searching...",
        no_matching_terms: "No terms matched.",
        delete_matching_terms: "Delete {{count}} matching term(s)",
        deleting: "Deleting...",
        date_added: "Date added",
        date_last_edited: "Last edited",
        filter_date_created_from: "Added from:",
        filter_date_created_to: "Added to:",
        filter_date_edited_from: "Last edited from:",
        filter_date_edited_to: "Last edited to:",
        bulk_delete_modal_title: "Delete matching terms?",
        bulk_delete_modal_warning: "This will permanently delete {{count}} term(s) matching your current filters. This cannot be undone.",
        bulk_delete_confirm_label: "Type {{count}} to confirm",
        bulk_delete_confirm_button: "Delete",
        reports_heading: "Reports",
        reports_help: "See how many terms were added, grouped by language and period.",
        report_period_label: "Group by:",
        report_period_day: "Day",
        report_period_week: "Week",
        report_period_month: "Month",
        run_report: "Run report",
        running_report: "Running report...",
        download_report_csv: "Download CSV",
        report_no_data: "No terms match these filters.",
        keep_a_merge_b: "Keep A, merge B in",
        keep_b_merge_a: "Keep B, merge A in",
        not_a_duplicate: "Not a duplicate",
        no_duplicates_found: "No duplicates or conflicts found.",
        filter_language: "Language:",
        filter_submitted_by: "Submitted by:",
        filter: "Filter",
        clear_filters: "Clear filters",
        all_languages_filter: "All languages",
        term_added: "'{{word}}' was added and is now pending review.",
        add_another_term: "Add another term",
        edit_this_term: "Edit this term",
        fuzziness_label: "Fuzziness:",
        statuses_label: "Statuses:",
        merge_all_exact: "Merge all exact matches ({{count}})",
        merge_all_exact_confirm: "This will merge {{count}} exact-duplicate matches. For each, one entry will be kept and the other deleted — this cannot be undone. Continue?",
        merge_all_exact_done: "Merged {{clusters}} exact-duplicate clusters ({{words}} entries deleted).",
        merging: "Merging…",
        // Claude: alpha-tester feedback — the "Term not found" dialog only had a "Back" button (testers
        // Claude: expected ✕/Close), and the "request a translation" option silently never appeared for
        // Claude: "All languages" searches. Non-English versions of these two keys are best-effort and
        // Claude: should get native-speaker review along with the rest of the catalogue.
        close: "Close",
        request_needs_target_language: "To request a translation, choose a specific target language and search again.",
        // Claude: search-result badge for PND terms (PendingBadge.js) — "Unverified" conveys the status
        // Claude: to a visitor unfamiliar with the review workflow better than the internal "Pending".
        unverified: "Unverified",
        // Claude: per-entry free-form notes (alpha-tester request) — shown only to logged-in users,
        // Claude: collapsed behind a "Show notes" toggle on the term page. Non-English/Afrikaans
        // Claude: versions are best-effort and should join the native-speaker review.
        notes: "Notes",
        show_notes: "Show notes",
        hide_notes: "Hide notes",
        notes_hint: "Only visible to logged-in users.",
        synonyms: "Synonyms",
        reset_password: "Reset password",
        new_password: "New password",
        confirm_new_password: "Confirm new password",
        current_password: "Current password",
        change_password: "Change password",
        send_reset_email: "Send reset email",
        forgot_password: "Forgotten password",
      },
    },
    af: {
      translation: {
        word: "Term",
        update_term: "Dateer inligting op",
        source: "Brontaal",
        target: "Teikentaal",
        partial: "Gedeeltelike passing",
        fuzzy: "Laat spelfoute toe",
        enter: "Tik soekterm hier in",
        terminology: "Terminologienaaf",
        alllanguages: "Alle tale",
        allstatus: "Enige status",
        search: "Soek",
        language: "Taal",
        context: "Konteks",
        add: "Voeg nuwe term by",
        advanced: "Uitgebreide soektog",
        accepted: "Aanvaar",
        pending: "Onder oorweging",
        ACC: "Aanvaar",
        PND: "Onder oorweging",
        REJ: "Verwerp",
        FLG: "Gemerk",
        rejected: "Verwerp",
        flagged: "Gemerk",
        status: "Status",
        translate_term: "Vertaal term",
        sourceword: "Bronterm",
        translatedterm: "Vertaalde term",
        example: "Voorbeeld",
        attribution: "Erkenning",
        newlanguage: "Nuwe taal",
        definition: "Definisie",
        school: "Skool",
        about: "Meer oor ons",
        contact: "Kontak ons",
        user_manual: "Gebruikershandleiding",
        addterm: "Voeg term by",
        termdetail: "Termbesonderhede",
        deleteconfirma: "Is u seker dat u '",
        deleteconfirmb: "' met konteks '",
        deleteconfirmc: "' in taal '",
        deleteconfirmd: "' wil uitvee?",
        yes: "Ja",
        no: "Nee",
        back: "Terug",
        translate: "Vertaal",
        update: "Dateer op",
        delete: "Vee uit",
        save: "Stoor",
        cancel: "Kanselleer",
        login: "Teken in",
        logout: "Teken uit",
        validation_word_required: "'n Woord word vereis.",
        validation_translation_required: "'n Vertaalde term word vereis.",
        something_went_wrong: "Iets het verkeerd geloop.",
        english_translation: "Engelse vertaling:",
        search_term_required: "'n Soekterm word vereis.",
        login_failed: "Aanmelding het misluk!",
        generic_error: "'n Fout het voorgekom",
        could_not_download_template: "Kon nie die sjabloon aflaai nie.",
        could_not_download_file: "Kon nie die lêer aflaai nie.",
        could_not_run_report: "Kon nie die verslag genereer nie.",
        could_not_delete_request: "Kon nie die versoek verwyder nie.",
        search_failed: "Soektog het misluk.",
        delete_failed: "Verwydering het misluk.",
        something_went_wrong_adding_term: "Iets het verkeerd geloop tydens die byvoeging van die term.",
        failed_to_add_term: "Kon nie die term byvoeg nie.",
        something_went_wrong_fetching_terms: "Iets het verkeerd geloop tydens die onttrekking van terme.",
        registration_failed: "Registrasie het misluk",
        confirmlogout: "Bevestig",
        register: "Registreer gebruiker",
        emailaddress: "Epos-adres",
        typeagain: "Tik die epos-adres weer",
        surname: "Van",
        firstname: "Voornaam",
        username: "Gebruikersnaam",
        password: "Wagwoord",
        message_username: "Die gebruikersnaam is nie beskikbaar nie.",
        message_email: "Die epos-adres is reeds geregistreer.",
        message_valid: "Die epos-adres is nie geldig nie.",
        message_notsame: "Die epos-adresse is nie dieselfde nie.",
        request_translation: "Versoek vertaling",
        submit_request: "Dien in",
        term_not_found: "Term nie in databasis nie.",
        submitsuccess: "Die versoek is suksesvol ingedien!",
        theterm: "Die term ",
        notfound: " is nie gevind nie.",
        liketorequest: "Wil u 'n versoek stuur dat 'n vertaling gesoek word?",
        suggest_translationa: "Wil u 'n moontlike vertaling na ",
        suggest_translationb: " voorstel?",
        ifsotype: "Indien wel, tik dit hieronder:",
        notranslation: "Geen vertaling is gevind nie.",
        add_request: "Voeg vertalingsversoek by",
        add_translation: "Vertaal",
        delete_request: "Verwyder versoek",
        delete_request_confirm: "Verwyder hierdie versoek? Dit kan nie ongedaan gemaak word nie.",
        suggested_translation: "Voorgestelde term",
        date_requested: "Datum versoek",
        action: "Aksie",
        no_requests: "Geen versoeke op rekord nie",
        r_user: "Geregistreerde gebruiker",
        editor: "Redakteur",
        date_edited_label: "Laas gewysig:",
        delete_a: "Vee A uit",
        delete_b: "Vee B uit",
        delete_word_confirm: "Vee '{{word}}' uit? Dit kan nie ontdaan word nie.",
        administrator: "Administrateur",
        requestlist: "Versoeke",
        word_to_be_added: "Term om by te voeg",
        pos: "Woordsoort",
        unknown: "Onbekend",
        noun: "Selfstandige naamwoord",
        verb: "Werkwoord",
        adjective: "Byvoeglike naamwoord",
        pronoun: "Voornaamwoord",
        adverb: "Bywoord",
        preposition: "Voorsetsel",
        conjunction: "Voegwoord",
        interjection: "Tussenwerpsel",
        article: "Lidwoord",
        suggests: "stel voor",
        wiktionary_lookup: "Soek op in Wiktionary",
        actions: "Aksies",
        review_queue: "Hersieningstou",
        my_suggestions: "My voorstelle",
        missing_terms: "Ontbrekende terme",
        duplicate_cleanup: "Duplikaatopruiming",
        english: "Engels",
        submitted_by: "Ingedien deur",
        days_pending: "Dae hangende",
        approve: "Keur goed",
        reject: "Verwerp",
        flag_action: "Merk",
        previous: "Vorige",
        next: "Volgende",
        nothing_waiting_review: "Niks wag vir hersiening nie.",
        showing_range: "Wys {{start}}–{{end}} van {{total}}",
        you_havent_submitted: "U het nog geen terme ingedien nie.",
        target_language: "Teikentaal:",
        nothing_missing: "Niks ontbreek vir hierdie taal nie.",
        match_type: "Ooreenkoms",
        word_a: "Woord A",
        word_b: "Woord B",
        english_reference_label: "Engels (slegs ter verwysing)",
        no_english_reference: "Geen Engelse verwysinginskrywing gevind nie.",
        user_admin: "Gebruikersadministrasie",
        approver: "Goedkeurder",
        role: "Rol",
        change_role: "Verander rol",
        download_csv_template: "Laai CSV-sjabloon af",
        upload_csv: "Laai CSV op",
        uploading: "Laai op...",
        upload_progress: "{{completed}} / {{total}} term(e) verwerk",
        upload_interrupted: "Oplaai onderbreek na {{completed}} van {{total}} term(e). Gaan die resultate na en laai die oorblywende rye weer op indien nodig.",
        choose_csv_file: "Kies CSV-lêer",
        bulk_upload_users: "Grootmaat-oplaai van gebruikers",
        bulk_upload_help: "Laai 'n CSV-lêer op om verskeie gebruikers gelyktydig te skep. Laai eers die sjabloon hieronder af om seker te maak die lêer is in die regte formaat.",
        temporary_password: "Tydelike wagwoord",
        temporary_password_notice: "Kopieer hierdie wagwoord nou en deel dit met die gebruiker — dit sal nie weer gewys word nie.",
        user_created: "Gebruiker '{{username}}' geskep.",
        delete_user_confirm: "Vee gebruiker '{{username}}' uit? Dit kan nie ontdaan word nie.",
        csv_upload_results: "Oplaairesultate",
        rows_created: "{{count}} gebruiker(s) geskep",
        terms_created: "{{count}} term(e) bygevoeg",
        duplicate_warning_title: "Moontlike duplikaat-invoer",
        duplicate_warning_message: "Al {{count}} term(e) in hierdie lêer bestaan reeds. Dit lyk of dieselfde lys weer ingevoer word.",
        replace_previous_import: "Vervang vorige invoer",
        add_in_any_case: "Voeg in elk geval by",
        rows_skipped: "{{count}} ry(e) oorgeslaan",
        row_label: "Ry",
        error_label: "Fout",
        existing_users: "Bestaande gebruikers",
        term_admin: "Termadministrasie",
        bulk_upload_terms: "Grootmaat-oplaai van terme",
        bulk_upload_terms_help: "Laai 'n CSV-lêer op om verskeie terme gelyktydig te skep, byvoorbeeld vanaf 'n lys wat elders saamgestel is. Laai eers die sjabloon hieronder af om seker te maak die lêer is in die regte formaat.",
        export_terms: "Voer terme uit",
        search_export_terms: "Soek / voer terme uit",
        export_terms_help: "Filtreer die terme hieronder, soek dan om te sien wat pas, voer hulle uit na CSV, of verwyder hulle in grootmaat.",
        export_csv: "Voer CSV uit",
        exporting: "Voer tans uit...",
        search_terms: "Soek",
        searching: "Soek tans...",
        no_matching_terms: "Geen terme het gepas nie.",
        delete_matching_terms: "Verwyder {{count}} passende term(e)",
        deleting: "Verwyder tans...",
        date_added: "Datum bygevoeg",
        date_last_edited: "Laas verander",
        filter_date_created_from: "Bygevoeg vanaf:",
        filter_date_created_to: "Bygevoeg tot:",
        filter_date_edited_from: "Laas verander vanaf:",
        filter_date_edited_to: "Laas verander tot:",
        bulk_delete_modal_title: "Verwyder passende terme?",
        bulk_delete_modal_warning: "Dit sal {{count}} term(e) wat aan u huidige filters voldoen permanent verwyder. Dit kan nie ongedaan gemaak word nie.",
        bulk_delete_confirm_label: "Tik {{count}} om te bevestig",
        bulk_delete_confirm_button: "Verwyder",
        reports_heading: "Verslae",
        reports_help: "Sien hoeveel terme bygevoeg is, gegroepeer volgens taal en tydperk.",
        report_period_label: "Groepeer volgens:",
        report_period_day: "Dag",
        report_period_week: "Week",
        report_period_month: "Maand",
        run_report: "Genereer verslag",
        running_report: "Genereer tans verslag...",
        download_report_csv: "Laai CSV af",
        report_no_data: "Geen terme voldoen aan hierdie filters nie.",
        keep_a_merge_b: "Hou A, voeg B by",
        keep_b_merge_a: "Hou B, voeg A by",
        not_a_duplicate: "Nie 'n duplikaat nie",
        no_duplicates_found: "Geen duplikate of konflikte gevind nie.",
        filter_language: "Taal:",
        filter_submitted_by: "Ingedien deur:",
        filter: "Filter",
        clear_filters: "Maak filters skoon",
        all_languages_filter: "Alle tale",
        term_added: "'{{word}}' is bygevoeg en wag nou vir hersiening.",
        add_another_term: "Voeg nog 'n term by",
        edit_this_term: "Wysig hierdie term",
        fuzziness_label: "Ooreenkomsvlak:",
        statuses_label: "Statusse:",
        merge_all_exact: "Voeg alle presiese ooreenkomste saam ({{count}})",
        merge_all_exact_confirm: "Dit sal {{count}} presiese duplikaat-ooreenkomste saamvoeg. Vir elkeen word een inskrywing behou en die ander uitgevee — dit kan nie ontdaan word nie. Gaan voort?",
        merge_all_exact_done: "{{clusters}} presiese duplikaatgroepe saamgevoeg ({{words}} inskrywings uitgevee).",
        merging: "Besig om saam te voeg…",
        close: "Sluit",
        request_needs_target_language: "Om 'n vertaling aan te vra, kies 'n spesifieke teikentaal en soek weer.",
        unverified: "Ongeverifieer",
        notes: "Notas",
        show_notes: "Wys notas",
        hide_notes: "Versteek notas",
        notes_hint: "Slegs sigbaar vir aangemelde gebruikers.",
        synonyms: "Sinonieme",
        reset_password: "Wagwoord herstel",
        new_password: "Nuwe wagwoord",
        confirm_new_password: "Bevestig nuwe wagwoord",
        current_password: "Huidige wagwoord",
        change_password: "Verander wagwoord",
        send_reset_email: "Stuur epos om wagwoord te herstel",
        forgot_password: "Vergete wagwoord",
      },
    },
    zu: {
      translation: {
        word: "Izwi",
        update_term: "Buyekeza ithemu",
        source: "Ulimi lomthombo",
        target: "Ulimi oluqondiwe",
        partial: "Ukufana okuncane",
        fuzzy: "Vumela amaphutha okupela",
        enter: "Faka igama lokusesha",
        terminology: "Ihabhu yamagama",
        alllanguages: "Zonke izilimi",
        search: "Sesha",
        language: "Ulimi",
        context: "Umongo",
        add: "Engeza ithemu entsha",
        advanced: "Ucwaningo olujulile",
        accepted: "Kwamukelwe",
        pending: "Kusalindile",
        rejected: "Kwaliwe",
        ACC: "Kwamukelwe",
        PND: "Kusalindile",
        REJ: "Kwaliwe",
        status: "Isimo",
        translate_term: "Humusha itemu",
        sourceword: "Igama lomthombo",
        translatedterm: "Itemu elihunyushiwe",
        example: "Isibonelo",
        attribution: "Isichasiso",
        newlanguage: "Ulimi olusha",
        definition: "Incazelo",
        school: "Isikole",
        about: "Mayelana nathi",
        contact: "Xhumana nathi",
        user_manual: "Incwadi yomsebenzisi",
        addterm: "Engeza ithemu",
        termdetail: "Imininingwane yethemu",
        deleteconfirma: "Uqinisekile ukuthi ufuna ukususa '",
        deleteconfirmb: "' onomongo'",
        deleteconfirmc: "' ngolimi'",
        deleteconfirmd: "'?",
        yes: "Yebo",
        no: "Cha",
        back: "Emuva",
        translate: "Humusha",
        update: "Buyekeza",
        delete: "Susa",
        cancel: "Ungakwenzi",
        login: "Ngena ngemvume",
        logout: "Phuma ngemvume",
        confirmlogout: "Qinisekisa ukuphuma",
        register: "Bhalisa umsebenzisi",
        emailaddress: "Ikheli le-imeyili",
        typeagain: "Faka ikheli le-imeyili futhi",
        surname: "Isibongo",
        firstname: "Igama",
        username: "Igama lomsebenzisi",
        password: "Iphasiwedi",
        message_username: "Igama lomsebenzisi selivele likhona. Khetha elinye.",
        message_email:
          "I-imeyili isivele ibhalisiwe. Sebenzisa enye i-imeyili.",
        message_valid: "Ikheli le-imeyili alisebenzi.",
        message_notsame: "Amakheli e-imeyili awafani.",
        request_translation: "Cela ukuhumusha",
        submit_request: "Thumela isicelo",
        term_not_found: "Igama alitholakalanga",
        submitsuccess: "Isicelo sithunyelwe ngempumelelo!",
        theterm: "Igama ",
        notfound: " alitholakalanga.",
        liketorequest: "Ungathanda ukufaka isicelo sokuhumusha?",
        suggest_translationa:
          "Ingabe ufuna ukusikisela igama kungenzeka ngesi ",
        suggest_translationb: "?",
        ifsotype: "Uma kunjalo, faka lapha:",
        notranslation: "Ayikho incazelo etholakele.",
        add_request: "Engeza igama eliceliwe",
        add_translation: "Engeza ukuhumusha",
        suggested_translation: "Ukuhumusha okusikiseliwe",
        date_requested: "Usuku olucelwe ngalo",
        action: "Isenzo",
        no_requests: "Awekho amasicelo atholakele",
        r_user: "Umsebenzisi ojwayelekile",
        editor: "Umhleli",
        date_edited_label: "Kuhlelwe kokugcina:",
        delete_a: "Susa A",
        delete_b: "Susa B",
        delete_word_confirm: "Susa '{{word}}'? Lokhu akukwazi ukuguqulwa.",
        administrator: "Umphathi",
        requestlist: "Amagama aceliwe",
        word_to_be_added: "Igama okufanele lengezwe",
        pos: "Ingxenye yokukhuluma",
        unknown: "Okungaziwa",
        noun: "Ibizo",
        verb: "Isenzo",
        adjective: "Isiphawulo",
        pronoun: "Isabizwana",
        adverb: "Isandiso",
        preposition: "Isandiso sendawo",
        conjunction: "Isihlanganiso",
        interjection: "Isiphawulo esihlanganisayo",
        article: "Isibabazo",
        suggests: "isikisela",
        wiktionary_lookup: "Bheka ku-Wiktionary",
        actions: "Izenzo",
        review_queue: "Uhlu lokubuyekeza",
        my_suggestions: "Iziphakamiso zami",
        missing_terms: "Amagama alahlekile",
        duplicate_cleanup: "Ukususa okuphindiwe",
        english: "IsiNgisi",
        submitted_by: "Kuthunyelwe ngu",
        days_pending: "Izinsuku zilindile",
        approve: "Vuma",
        reject: "Yenqaba",
        flag_action: "Phawula",
        previous: "Okwedlule",
        next: "Okulandelayo",
        nothing_waiting_review: "Akukho okulindele ukubuyekezwa.",
        showing_range: "Kukhonjiswa u-{{start}}–{{end}} kwangu-{{total}}",
        you_havent_submitted: "Awukafaki noma yiliphi igama okwamanje.",
        target_language: "Ulimi olulethelwayo:",
        nothing_missing: "Akukho okushodayo kulolu limi.",
        match_type: "Ukufana",
        word_a: "Igama A",
        word_b: "Igama B",
        english_reference_label: "IsiNgisi (kuphela okokubhekisela)",
        no_english_reference: "Ayikho inqolobane yesiNgisi etholakele.",
        user_admin: "Ukulawulwa Kwabasebenzisi",
        approver: "Umvumi",
        role: "Indima",
        change_role: "Shintsha indima",
        download_csv_template: "Landa isifanekiso se-CSV",
        upload_csv: "Layisha i-CSV",
        uploading: "Iyalayisha...",
        upload_progress: "amagama angu-{{completed}} kwangu-{{total}} acutshungulwe",
        upload_interrupted: "Ukulayisha kuphazamisekile ngemuva kuka-{{completed}} kwangu-{{total}} amagama. Sicela uhlole imiphumela bese uphinda ulayishe imigqa esele uma kudingeka.",
        choose_csv_file: "Khetha ifayela le-CSV",
        bulk_upload_users: "Layisha abasebenzisi abaningi ngaso sonke isikhathi",
        bulk_upload_help: "Layisha ifayela le-CSV ukudala abasebenzisi abaningi ngesikhathi esisodwa. Landa isifanekiso ngezansi kuqala ukuqinisekisa ukuthi ifayela lisefomethini elifanele.",
        temporary_password: "Iphasiwedi yesikhashana",
        temporary_password_notice: "Kopisha le phasiwedi manje uyabelane nomsebenzisi — ngeke iphinde iboniswe.",
        user_created: "Umsebenzisi '{{username}}' udaliwe.",
        delete_user_confirm: "Susa umsebenzisi '{{username}}'? Lokhu akukwazi ukuguqulwa.",
        csv_upload_results: "Imiphumela yokulayisha",
        rows_created: "abasebenzisi abangu-{{count}} badaliwe",
        terms_created: "amagama angu-{{count}} engeziwe",
        duplicate_warning_title: "Ukungenisa okungenzeka kuphindiwe",
        duplicate_warning_message: "Wonke amagama angu-{{count}} kulelifayela asevele ekhona. Lokhu kubonakala sengathi luhlu olufanayo luyangeniswa futhi.",
        replace_previous_import: "Shintsha ukungenisa kwangaphambilini",
        add_in_any_case: "Faka noma kunjalo",
        rows_skipped: "imigqa engu-{{count}} idluliwe",
        row_label: "Umugqa",
        error_label: "Iphutha",
        existing_users: "Abasebenzisi asebekhona",
        term_admin: "Ukulawulwa Kwamagama",
        bulk_upload_terms: "Layisha amagama amaningi ngasikhathi sinye",
        bulk_upload_terms_help: "Layisha ifayela le-CSV ukudala amagama amaningi ngesikhathi esisodwa, isibonelo kusuka ohlwini olwenziwe kwenye indawo. Landa isifanekiso ngezansi kuqala ukuqinisekisa ukuthi ifayela lisefomethini elifanele.",
        export_terms: "Thumela amagama ngaphandle",
        export_terms_help: "Thumela amagama ahluziwe ngezansi ngaphandle kufayela le-CSV, kufaka wonke amasimu.",
        export_csv: "Thumela i-CSV ngaphandle",
        exporting: "Iyathumela ngaphandle...",
        keep_a_merge_b: "Gcina A, hlanganisa B",
        keep_b_merge_a: "Gcina B, hlanganisa A",
        not_a_duplicate: "Akuwona umfanekiso ophindiwe",
        no_duplicates_found: "Akutholakalanga okuphindiwe noma okuphikisanayo.",
        filter_language: "Ulimi:",
        filter_submitted_by: "Kuthunyelwe ngu:",
        filter: "Hlunga",
        clear_filters: "Sula izihlungi",
        all_languages_filter: "Zonke izilimi",
        term_added: "'{{word}}' selokwe futhi ilinde ukubuyekezwa.",
        add_another_term: "Engeza elinye igama",
        edit_this_term: "Hlela leli gama",
        fuzziness_label: "Izinga lokufana:",
        statuses_label: "Izimo:",
        merge_all_exact: "Hlanganisa konke okufana ngokuphelele ({{count}})",
        merge_all_exact_confirm: "Lokhu kuzohlanganisa okufana ngokuphelele okungu-{{count}}. Kokubili, okukodwa kuzogcinwa okunye kususwe — lokhu akukwazi ukuguqulwa. Qhubeka?",
        merge_all_exact_done: "Kuhlanganiswe amaqoqo okuphindiwe angu-{{clusters}} (okungu-{{words}} kususiwe).",
        merging: "Iyahlanganisa…",
        close: "Vala",
        request_needs_target_language: "Ukuze ucele ukuhumusha, khetha ulimi oluhlosiwe oluthile bese usesha futhi.",
        unverified: "Akuqinisekisiwe",
        notes: "Amanothi",
        show_notes: "Bonisa amanothi",
        hide_notes: "Fihla amanothi",
        notes_hint: "Kubonakala kuphela kubasebenzisi abangene ngemvume.",
        synonyms: "Sinonimu",
        reset_password: "Setha kabusha iphasiwedi",
        new_password: "Iphasiwedi entsha",
        confirm_new_password: "Qinisekisa iphasiwedi entsha",
        current_password: "Iphasiwedi yamanje",
        change_password: "Shintsha iphasiwedi",
        send_reset_email: "Thumela i-imeyili ukuze usethe kabusha iphasiwedi",
        forgot_password: "Ukhohlwe igama-mfihlo",
      },
    },
    st: {
      translation: {
        word: "Lentsoe",
        update_term: "Nchafatso nako",
        source: "Puo ea mohloli",
        target: "Puo e reriloeng",
        partial: "Papali e sa fellang",
        fuzzy: "Dumella diphoso tsa mopeleto",
        enter: "Kenya lentsoe la ho batla",
        terminology: "Setsi sa Mareo",
        alllanguages: "Lipuo tsohle",
        search: "Batla",
        language: "Puo",
        context: "Moelelo",
        add: "Kenya lentsoe le lecha",
        advanced: "Patlisiso e tsoetseng pele",
        accepted: "E amohetsoe",
        pending: "E emetse",
        rejected: "Hanoa",
        ACC: "E amohetsoe",
        PND: "E emetse",
        REJ: "Hanoa",
        status: "Boemo",
        translate_term: "Lereho la ho fetolela",
        sourceword: "Mohloli nako",
        translatedterm: "Lereho le fetoletsoeng",
        example: "Mohlala",
        attribution: "Tlhahiso",
        newlanguage: "Puo e ncha",
        definition: "Tlhaloso",
        school: "Sekolo",
        about: "Mabapi le rona",
        contact: "Iteanye le rona",
        user_manual: "Tataiso ea mosebedisi",
        addterm: "Kenya nako",
        termdetail: "Lintlha tsa nako",
        deleteconfirma: "Na u na le bonnete ba hore u batla ho hlakola '",
        deleteconfirmb: "'le moelelo oa taba'",
        deleteconfirmc: "'ka puo'",
        deleteconfirmd: "'?",
        yes: "Ee",
        no: "Che",
        back: "Morao",
        translate: "Fetolela",
        update: "Nchafatso",
        delete: "Hlakola",
        cancel: "Iphapanyetsa",
        login: "Kena",
        logout: "Tsoa",
        confirmlogout: "Netefatsa ho tsoa",
        register: "Ngodisa mosebedisi",
        emailaddress: "Aterese ya imeile",
        typeagain: "Kenya aterese ya imeile hape",
        surname: "Fane",
        firstname: "Lebitso la pele",
        username: "Lebitso la mosebedisi",
        password: "Password",
        message_username: "Lebitso la mosebedisi le teng. Kgetha le leng.",
        message_email: "Imeile e se e ngodisitswe. Sebelisa imeile e nngwe.",
        message_valid: "Aterese ya imeile ha e nepahe.",
        message_notsame: "Diaterese tsa imeile ha di tshwane.",
        request_translation: "Kopa phetolelo",
        submit_request: "Romela kopo",
        term_not_found: "Lentsoe ha le a fumaneha",
        submitsuccess: "Kopo e rometswe ka katleho!",
        theterm: "Lentsoe ",
        notfound: " ha le a fumaneha.",
        liketorequest: "O rata ho kopa phetolelo?",
        suggest_translationa:
          "O batla ho fana ka tlhahiso ya lentsoe le ka kgonehang ka ",
        suggest_translationb: "?",
        ifsotype: "Ha ho le jwalo, le kenya mona:",
        notranslation: "Ha ho phetolelo e fumanehileng.",
        add_request: "Kenya lentsoe le kopilweng",
        add_translation: "Kenya phetolelo",
        suggested_translation: "Phetolelo e hlalositsweng",
        date_requested: "Letsatsi le kopilweng",
        action: "Ketso",
        no_requests: "Ha ho likopo tse fumanehileng",
        r_user: "Mosebedisi ya tlwaelehileng",
        editor: "Mohlohleli",
        date_edited_label: "E fetotswe la ho qetela:",
        delete_a: "Hlakola A",
        delete_b: "Hlakola B",
        delete_word_confirm: "Hlakola '{{word}}'? Sena se ke ke sa fetolwa.",
        administrator: "Motsamaisi",
        requestlist: "Mantsoe a kopilweng",
        word_to_be_added: "Lentsoe le tla kenngwa",
        pos: "Karolo ya puo",
        unknown: "Ha ho tsejwa",
        noun: "Lebitso",
        verb: "Leetsi",
        adjective: "Lehlalosisi",
        pronoun: "Lebitsokgethi",
        adverb: "Lehlalosisi la leetsi",
        preposition: "Leetsi la boemo",
        conjunction: "Sehlomathiso",
        interjection: "Lentswe la mokgwa",
        article: "Sehlomathiso",
        suggests: "fana ka tlhahiso",
        wiktionary_lookup: "Sheba ho Wiktionary",
        actions: "Diketso",
        review_queue: "Lenane la tlhahlobo",
        my_suggestions: "Ditlhahiso tsa ka",
        missing_terms: "Mantswe a sa fumanehang",
        duplicate_cleanup: "Tlhwekiso ya diphetiso",
        english: "Senyesemane",
        submitted_by: "E rometswe ke",
        days_pending: "Matsatsi a emetseng",
        approve: "Dumela",
        reject: "Hana",
        flag_action: "Tshwaya",
        previous: "E fetileng",
        next: "E latelang",
        nothing_waiting_review: "Ha ho letho le emetseng tlhahlobo.",
        showing_range: "E bontsha {{start}}–{{end}} ho {{total}}",
        you_havent_submitted: "Ha o so romele mantswe le a le mong.",
        target_language: "Puo e lebisitsweng:",
        nothing_missing: "Ha ho letho le hlokahalang bakeng sa puo ena.",
        match_type: "Tshwano",
        word_a: "Lentswe A",
        word_b: "Lentswe B",
        english_reference_label: "Senyesemane (bakeng sa tšupiso feela)",
        no_english_reference: "Ha ho na tlatsetso ya Senyesemane e fumanweng.",
        user_admin: "Tsamaiso ya Basebedisi",
        approver: "Motumelli",
        role: "Karolo",
        change_role: "Fetola karolo",
        download_csv_template: "Jarolla template ya CSV",
        upload_csv: "Kenya CSV",
        uploading: "E a kenya...",
        upload_progress: "mantswe a {{completed}} ho tswa ho a {{total}} a sebeditswe",
        upload_interrupted: "Ho kenya ho kgaotsitswe kamora a {{completed}} ho tswa ho a {{total}}. Ka kopo hlahloba diphetho mme o kenye hape mela e setseng haeba ho hlokahala.",
        choose_csv_file: "Kgetha faele ya CSV",
        bulk_upload_users: "Kenya basebedisi ba bangata ka nako e le nngwe",
        bulk_upload_help: "Kenya faele ya CSV ho theha basebedisi ba bangata ka nako e le nngwe. Jarolla template ka tlase pele, ho netefatsa hore faele e mofuteng o nepahetseng.",
        temporary_password: "Password ya nakwana",
        temporary_password_notice: "Kopa password ena hona jwale mme o e arolelane le mosebedisi — ha e sa tla bontshwa hape.",
        user_created: "Mosebedisi '{{username}}' o thehilwe.",
        delete_user_confirm: "Hlakola mosebedisi '{{username}}'? Sena se ke ke sa fetolwa.",
        csv_upload_results: "Diphetho tsa ho kenya",
        rows_created: "basebedisi ba {{count}} ba thehilwe",
        terms_created: "mantswe a {{count}} a kentsoe",
        duplicate_warning_title: "Ho kenya ho ka etsahalang ha babeli",
        duplicate_warning_message: "Mantswe ohle a {{count}} ho faele ena a se a le teng. Sena se bonahala eka lenane le tshwanang le kenywa hape.",
        replace_previous_import: "Nkgetha ho kenya ha pele",
        add_in_any_case: "Kenya leha ho le jwalo",
        rows_skipped: "mela e {{count}} e tlotsitswe",
        row_label: "Mola",
        error_label: "Phoso",
        existing_users: "Basebedisi ba se ba le teng",
        term_admin: "Tsamaiso ya Mantswe",
        bulk_upload_terms: "Kenya mantswe a mangata ka nako e le nngwe",
        bulk_upload_terms_help: "Kenya faele ya CSV ho theha mantswe a mangata ka nako e le nngwe, mohlala ho tswa lenaneng le hlophisitsweng kae kae. Jarolla template ka tlase pele, ho netefatsa hore faele e mofuteng o nepahetseng.",
        export_terms: "Ntsha mantswe",
        export_terms_help: "Ntsha mantswe a fetotsweng ka tlase ho ya faeleng ya CSV, ho kenyeletswa tshimo e nngwe le e nngwe.",
        export_csv: "Ntsha CSV",
        exporting: "E a ntsha...",
        keep_a_merge_b: "Boloka A, kopanya B",
        keep_b_merge_a: "Boloka B, kopanya A",
        not_a_duplicate: "Hase kopi",
        no_duplicates_found: "Ha ho dikopi kapa dikgohlano tse fumanweng.",
        filter_language: "Puo:",
        filter_submitted_by: "E rometswe ke:",
        filter: "Sefa",
        clear_filters: "Hlakola disefo",
        all_languages_filter: "Dipuo tsohle",
        term_added: "'{{word}}' e kentswe mme e emetse tlhahlobo.",
        add_another_term: "Kenya lentswe le leng",
        edit_this_term: "Fetola lentswe lena",
        fuzziness_label: "Tekano ya ho tshwana:",
        statuses_label: "Maemo:",
        merge_all_exact: "Kopanya ditshwano tsohle tse feletseng ({{count}})",
        merge_all_exact_confirm: "Sena se tla kopanya ditshwano tse feletseng tse {{count}}. Ho e nngwe le e nngwe, ho tla bolokwa e le nngwe mme e nngwe e hlakolwe — sena se ke ke sa fetolwa. Tswela pele?",
        merge_all_exact_done: "Ho kopantswe dihlopha tse {{clusters}} tsa ditshwano tse feletseng ({{words}} tse hlakotsweng).",
        merging: "E a kopanya…",
        close: "Kwala",
        request_needs_target_language: "Ho kopa phetolelo, kgetha puo e itseng eo o e lebisitseng mme o batle hape.",
        unverified: "Ha e so netefatswe",
        notes: "Dintlha",
        show_notes: "Bontsha dintlha",
        hide_notes: "Pata dintlha",
        notes_hint: "Di bonahala feela ho basebedisi ba keneng.",
      },
    },
    nso: {
      translation: {
        word: "Lentšu",
        update_term: "Update nako",
        source: "Polelo ya mothopo",
        target: "Polelo ye e nepišitšwego",
        partial: "Papadi ya karolo",
        fuzzy: "Dumelela diphošo tša mopeloto",
        enter: "Kenya lereo la nyakišišo",
        terminology: "Mareo Hub",
        alllanguages: "Maleme ka moka",
        search: "Nyaka",
        language: "Polelo",
        context: "Kamano",
        add: "Oketša lereo le lefsa",
        advanced: "Patlo ya maemo a godimo",
        accepted: "E amogetšwe",
        pending: "Letetšwe",
        rejected: "E gannwe",
        ACC: "E amogetšwe",
        PND: "Letetšwe",
        REJ: "E gannwe",
        status: "Maemo",
        translate_term: "Fetolela lereo",
        sourceword: "Polelo ya mothopo",
        translatedterm: "Polelo ye e fetoletšwego",
        example: "Mohlala",
        attribution: "Go abela",
        newlanguage: "Polelo ye mpsha",
        definition: "Tlhalošo",
        school: "Sekolo",
        about: "Mabapi le rena",
        contact: "Ikgokaganye le rena",
        user_manual: "Tlhahlo ya modiriši",
        addterm: "Oketša lereo",
        termdetail: "Dintlha tša nako",
        deleteconfirma: "Na o na le bonnete bja gore o nyaka go phumola '.",
        deleteconfirmb: "' ka seemo '.",
        deleteconfirmc: "' ka polelo ' .",
        deleteconfirmd: "'?",
        yes: "Ee",
        no: "Aowa",
        back: "Morago",
        translate: "Fetolela",
        update: "Mpshafatša",
        delete: "Phumola",
        cancel: "Hlokomologa",
        login: "Tsena",
        logout: "Tšwa",
        confirmlogout: "Netefatša go tšwa",
        register: "Ngwadiša mošomi",
        emailaddress: "Aderese ya emeile",
        typeagain: "Tsenya aterese ya emeile gape",
        surname: "Sefane",
        firstname: "Leina la pele",
        username: "Leina la mošomi",
        password: "Phasewete",
        message_username:
          "Leina la mošomi le šetše le gona. Hle kgetha le lengwe.",
        message_email:
          "Emeile e šetše e ngwadišitšwe. Hle šomiša emeile e nngwe.",
        message_valid: "Aderese ya emeile ga e nepagale.",
        message_notsame: "Diaderese tša emeile ga di swane.",
        request_translation: "Kopa phetolelo",
        submit_request: "Romela kgopelo",
        term_not_found: "Lentšu ga le hwetšagale",
        submitsuccess: "Kgopelo e rometšwe ka katlego!",
        theterm: "Lentšu ",
        notfound: " ga le hwetšagale.",
        liketorequest: "O nyaka go kopa phetolelo?",
        suggest_translationa: "O nyaka go šišinya lentšu le ka bago ka ",
        suggest_translationb: "?",
        ifsotype: "Ge e le bjalo, tsenya fa:",
        notranslation: "Ga go phetolelo yeo e hwetšwago.",
        add_request: "Tsenya lentšu le kgopetšwego",
        add_translation: "Tsenya phetolelo",
        suggested_translation: "Phetolelo ye e šišintšwego",
        date_requested: "Letšatši le kgopetšwego",
        action: "Kgato",
        no_requests: "Ga go kgopelo yeo e hwetšwago",
        r_user: "Mošomi wa ka mehla",
        editor: "Mohlopholli",
        date_edited_label: "E fetotšwe la mafelelo:",
        delete_a: "Phumola A",
        delete_b: "Phumola B",
        delete_word_confirm: "Phumola '{{word}}'? Se ke se ka fetolwa.",
        administrator: "Mohlokomedi",
        requestlist: "Mantšu a kgopetšwego",
        word_to_be_added: "Lentšu leo le swanetšego go tsenywa",
        pos: "Karolo ya polelo",
        unknown: "Ga go tsebege",
        noun: "Leina",
        verb: "Leetsi",
        adjective: "Lehlalosi",
        pronoun: "Leina le thopago",
        adverb: "Lehlalosetsi",
        preposition: "Lehlalosi la maemo",
        conjunction: "Sehlamela",
        interjection: "Lehlalosabjale",
        article: "Lentšu le lekanyago",
        suggests: "šišinya",
        wiktionary_lookup: "Lebelela go Wiktionary",
        actions: "Mediro",
        review_queue: "Lenaneo la tekolo",
        my_suggestions: "Ditshishinyo tsa ka",
        missing_terms: "Mantshu ao a sa hwetshagalego",
        duplicate_cleanup: "Phepafatso ya diphetisho",
        english: "Seisemane",
        submitted_by: "E romilwe ke",
        days_pending: "Matsatsi ao a emetšego",
        approve: "Dumela",
        reject: "Gana",
        flag_action: "Swaya",
        previous: "Pele",
        next: "Latelago",
        nothing_waiting_review: "Ga go selo se se emetšego tlhahlobo.",
        showing_range: "E bontšha {{start}}–{{end}} go {{total}}",
        you_havent_submitted: "Ga o se wa romela mantšu le ge e le afe.",
        target_language: "Leleme le lebišitšwego:",
        nothing_missing: "Ga go selo se se hlokegago bakeng sa leleme le.",
        match_type: "Go swana",
        word_a: "Lentšu A",
        word_b: "Lentšu B",
        english_reference_label: "Seisemane (bakeng sa tšupetšo fela)",
        no_english_reference: "Ga go na tlatsetšo ya Seisemane e hweditšwego.",
        user_admin: "Taolo ya Badiriši",
        approver: "Motumelela",
        role: "Karolo",
        change_role: "Fetola karolo",
        download_csv_template: "Laolla template ya CSV",
        upload_csv: "Tsenya CSV",
        uploading: "E a tsenya...",
        upload_progress: "mareo a {{completed}} go a {{total}} a diriwe",
        upload_interrupted: "Go tsenya go kgaoditšwe ka morago ga a {{completed}} go a {{total}}. Hlahloba dipoelo gomme o tsenye gape mela ye e šetšego ge go nyakega.",
        choose_csv_file: "Kgetha faele ya CSV",
        bulk_upload_users: "Tsenya badiriši ba bantši ka nako e tee",
        bulk_upload_help: "Tsenya faele ya CSV go hlama badiriši ba bantši ka nako e tee. Laolla template ka mo tlase pele, go kgonthišiša gore faele e sebopegong se se nepagetšego.",
        temporary_password: "Phasiwete ya nakwana",
        temporary_password_notice: "Kopa phasiwete ye gona bjale gomme o e abelane le modiriši — e ka se hlwe e bontšhwa gape.",
        user_created: "Modiriši '{{username}}' o hlamilwe.",
        delete_user_confirm: "Phumola modiriši '{{username}}'? Se ke se ka fetolwa.",
        csv_upload_results: "Dipoelo tša go tsenya",
        rows_created: "badiriši ba {{count}} ba hlamilwe",
        terms_created: "mareo a {{count}} a tsentšwe",
        duplicate_warning_title: "Go tsenya mo go ka bago ga tshwana",
        duplicate_warning_message: "Mareo ohle a {{count}} ka faeleng ye a šetše a le gona. Se se bonagala eka lenaneo le swanago le tsenywa gape.",
        replace_previous_import: "Tšeafatša tsenyo ya peleng",
        add_in_any_case: "Tsenya le ge go le bjalo",
        rows_skipped: "mela ya {{count}} e tlotšitšwe",
        row_label: "Mola",
        error_label: "Phošo",
        existing_users: "Badiriši bao šetšego ba le gona",
        term_admin: "Taolo ya Mareo",
        bulk_upload_terms: "Tsenya mareo a mantši ka nako e tee",
        bulk_upload_terms_help: "Tsenya faele ya CSV go hlama mareo a mantši ka nako e tee, mohlala go tšwa lenaneong le beetšwego mo gongwe. Laolla template ka mo tlase pele, go kgonthišiša gore faele e sebopegong se se nepagetšego.",
        export_terms: "Ntšha mareo",
        export_terms_help: "Ntšha mareo a sefilwego ka mo tlase go ya faeleng ya CSV, go akaretša tshimo ye nngwe le ye nngwe.",
        export_csv: "Ntšha CSV",
        exporting: "E a ntšha...",
        keep_a_merge_b: "Boloka A, kopanya B",
        keep_b_merge_a: "Boloka B, kopanya A",
        not_a_duplicate: "Ga se kopi",
        no_duplicates_found: "Ga go kopi goba dikgohlano tše di hweditšwego.",
        filter_language: "Leleme:",
        filter_submitted_by: "E romilwe ke:",
        filter: "Sefa",
        clear_filters: "Hlakola disefo",
        all_languages_filter: "Maleme ka moka",
        term_added: "'{{word}}' e tsentšwe mme e emetše tlhahlobo.",
        add_another_term: "Tsenya lentšu le lengwe",
        edit_this_term: "Fetola lentšu le",
        fuzziness_label: "Tekanyo ya go swana:",
        statuses_label: "Maemo:",
        merge_all_exact: "Kopanya ditshwano tšohle tše di feletšego ({{count}})",
        merge_all_exact_confirm: "Se se tla kopanya ditshwano tše di feletšego tše {{count}}. Go se sengwe le se sengwe, e tee e tla bolokwa yeo e nngwe e hlakolwa — se ke se ka fetolwa. Tšwela pele?",
        merge_all_exact_done: "Go kopantšwe dihlopha tše {{clusters}} tša ditshwano tše feletšego ({{words}} di hlakotšwe).",
        merging: "E a kopanya…",
        close: "Tswalela",
        request_needs_target_language: "Go kgopela phetolelo, kgetha polelo ye itšego ya nepo gomme o nyake gape.",
        unverified: "Ga se ya netefatšwa",
        notes: "Dintlha",
        show_notes: "Bontšha dintlha",
        hide_notes: "Uta dintlha",
        notes_hint: "Di bonagala fela go badiriši bao ba tsenego.",
      },
    },
    tn: {
      translation: {
        word: "Lefoko",
        update_term: "Ntšhwafatsa paka",
        source: "Puo ya motswedi",
        target: "Puo e e ikaeletsweng",
        partial: "Bontlhanngwe jwa tshwano",
        fuzzy: "Letla diphoso tsa mopeleto",
        enter: "Tsenya lereo la patlo",
        terminology: "Lefelo la Mareo",
        alllanguages: "Dipuo tsotlhe",
        search: "Phuruphutsa",
        language: "Puo",
        context: "Bokao",
        add: "Tsenya lereo le lešwa",
        advanced: "Patlo e e tseneletseng",
        accepted: "E amogetswe",
        pending: "Letetse",
        rejected: "E gannwe",
        ACC: "E amogetswe",
        PND: "Letetse",
        REJ: "E gannwe",
        status: "Seemo",
        translate_term: "Ranola lereo",
        sourceword: "Lereo la motswedi",
        translatedterm: "Lereo le le ranotsweng",
        example: "Sekai",
        attribution: "Tlhaloso",
        newlanguage: "Puo e ntšhwa",
        definition: "Tlhaloso",
        school: "Sekolo",
        about: "Ka ga rona",
        contact: "Ikgolaganye le rona",
        user_manual: "Kaedi ya modirisi",
        addterm: "Tsenya lereo",
        termdetail: "Dintlha tsa paka",
        deleteconfirma: "A o tlhomamisa gore o batla go phimola '",
        deleteconfirmb: "' ka bokao '",
        deleteconfirmc: "' ka puo '",
        deleteconfirmd: "'?",
        yes: "ee",
        no: "nnyaa",
        back: "Morago",
        translate: "Fetolela",
        update: "Tlhabolola",
        delete: "Phimola",
        cancel: "Khansela",
        login: "Tsenya",
        logout: "Tswala",
        confirmlogout: "Netefatsa go tswa",
        register: "Ngodisa mosomi",
        emailaddress: "Aterese ya emeile",
        typeagain: "Tsenya aterese ya emeile gape",
        surname: "Sefane",
        firstname: "Leina la ntlha",
        username: "Leina la mosomi",
        password: "Password",
        message_username: "Leina la mosomi le teng. Kgetha le lengwe.",
        message_email: "Emeile e setse e ngodisiwe. Dira ka e nngwe.",
        message_valid: "Aterese ya emeile ga e a siama.",
        message_notsame: "Diaterese tsa emeile ga di tshwane.",
        request_translation: "Kopa phetolelo",
        submit_request: "Romela kopo",
        term_not_found: "Lefoko ga le a fitlhelwa",
        submitsuccess: "Kopo e rometswe ka katlego!",
        theterm: "Lefoko ",
        notfound: " ga le a fitlhelwa.",
        liketorequest: "A o rata go kopa phetolelo?",
        suggest_translationa:
          "A o batla go naya tlhahiso ya lefoko le le ka kgonegang ka ",
        suggest_translationb: "?",
        ifsotype: "Fa go le jalo, tsenya mo go:",
        notranslation: "Ga go na phetolelo e e fitlhelwang.",
        add_request: "Tsenya lefoko le le kopiwang",
        add_translation: "Tsenya phetolelo",
        suggested_translation: "Phetolelo e e tshitshinnyweng",
        date_requested: "Letsatsi le kopiwang ka lona",
        action: "Tiro",
        no_requests: "Ga go na dikopo tse di fitlhelwang",
        r_user: "Mosomi wa tlwaelo",
        editor: "Mohlophisi",
        date_edited_label: "E fetotswe la bofelo:",
        delete_a: "Phimola A",
        delete_b: "Phimola B",
        delete_word_confirm: "Phimola '{{word}}'? Se ga se kgone go fetolwa.",
        administrator: "Mokhanselara",
        requestlist: "Mafoko a a kopiwang",
        word_to_be_added: "Lefoko le le ka tsenywang",
        pos: "Karolo ya puo",
        unknown: "Ga go itsiwe",
        noun: "Leina",
        verb: "Leetsi",
        adjective: "Lehlalosetsi",
        pronoun: "Leina le le kgethegileng",
        adverb: "Lehlalosetsi la leetsi",
        preposition: "Leina le tshwantshang maemo",
        conjunction: "Seamodimo",
        interjection: "Lehlalosabjale",
        article: "Selalelo",
        suggests: "tshitshinya",
        wiktionary_lookup: "Leba mo Wiktionary",
        actions: "Ditiro",
        review_queue: "Lenaane la tshekatsheko",
        my_suggestions: "Ditshitshinyo tsa me",
        missing_terms: "Mafoko a a sa fitlhelweng",
        duplicate_cleanup: "Phepafatso ya diphetolelo",
        english: "Sekgoa",
        submitted_by: "E romilwe ke",
        days_pending: "Malatsi a a letetseng",
        approve: "Dumalana",
        reject: "Gana",
        flag_action: "Tshwaya",
        previous: "Pele",
        next: "Latelang",
        nothing_waiting_review: "Ga go na sepe se se letetseng tekolo.",
        showing_range: "E bontsha {{start}}–{{end}} go {{total}}",
        you_havent_submitted: "Ga o ise o romele mafoko le fa e le a le mangwe.",
        target_language: "Puo e e lebisitsweng:",
        nothing_missing: "Ga go na sepe se se tlhokegang mo puong e.",
        match_type: "Go tshwana",
        word_a: "Lefoko A",
        word_b: "Lefoko B",
        english_reference_label: "Seesemane (fela go bontsha)",
        no_english_reference: "Ga go na tekanyetso ya Seesemane e e fitlhetsweng.",
        user_admin: "Tsamaiso ya Badirisi",
        approver: "Motumeledi",
        role: "Seabe",
        change_role: "Fetola seabe",
        download_csv_template: "Kolobetsa template ya CSV",
        upload_csv: "Tsenya CSV",
        uploading: "E a tsenya...",
        upload_progress: "mafoko a {{completed}} go a {{total}} a dirilwe",
        upload_interrupted: "Go tsenya go kgaotswe morago ga a {{completed}} go a {{total}}. Tsweetswee sekaseka dipholo mme o tsenye gape mela e e setseng fa go tlhokega.",
        choose_csv_file: "Tlhopha faele ya CSV",
        bulk_upload_users: "Tsenya badirisi ba le bantsi ka nako e le nngwe",
        bulk_upload_help: "Tsenya faele ya CSV go tlhama badirisi ba le bantsi ka nako e le nngwe. Kolobetsa template kwa tlase pele, go netefatsa gore faele e mo sebopegong se se siameng.",
        temporary_password: "Password ya nakwana",
        temporary_password_notice: "Kopa password e jaanong mme o e abalane le modirisi — ga e kitla e tlhola e bontshiwa.",
        user_created: "Modirisi '{{username}}' o tlhamilwe.",
        delete_user_confirm: "Phimola modirisi '{{username}}'? Se ga se kgone go fetolwa.",
        csv_upload_results: "Dipholo tsa go tsenya",
        rows_created: "badirisi ba {{count}} ba tlhamilwe",
        terms_created: "mafoko a {{count}} a tsentswe",
        duplicate_warning_title: "Go tsenya go go ka tshwanang",
        duplicate_warning_message: "Mafoko otlhe a {{count}} mo faeleng eno a setse a le teng. Se se lebega e kete lenaane le le tshwanang le tsenngwa gape.",
        replace_previous_import: "Emisa tsenyo ya pele",
        add_in_any_case: "Tsenya le fa go ntse jalo",
        rows_skipped: "mela e {{count}} e tlotsitswe",
        row_label: "Mola",
        error_label: "Phoso",
        existing_users: "Badirisi ba setseng ba le teng",
        term_admin: "Tsamaiso ya Mafoko",
        bulk_upload_terms: "Tsenya mafoko a le mantsi ka nako e le nngwe",
        bulk_upload_terms_help: "Tsenya faele ya CSV go tlhama mafoko a le mantsi ka nako e le nngwe, sekai go tswa lenaaneng le le rulagantsweng gongwe. Kolobetsa template kwa tlase pele, go netefatsa gore faele e mo sebopegong se se siameng.",
        export_terms: "Ntsha mafoko",
        export_terms_help: "Ntsha mafoko a a sefilweng kwa tlase go ya faeleng ya CSV, go akaretsa tshimo nngwe le nngwe.",
        export_csv: "Ntsha CSV",
        exporting: "E a ntsha...",
        keep_a_merge_b: "Boloka A, kopanya B",
        keep_b_merge_a: "Boloka B, kopanya A",
        not_a_duplicate: "Ga se kopi",
        no_duplicates_found: "Ga go na dikopi kgotsa dikgotlhang tse di fitlhetsweng.",
        filter_language: "Puo:",
        filter_submitted_by: "E romilwe ke:",
        filter: "Sefa",
        clear_filters: "Phimola disefe",
        all_languages_filter: "Dipuo tsotlhe",
        term_added: "'{{word}}' e tsentswe mme e letile tekolo.",
        add_another_term: "Tsenya lefoko le lengwe",
        edit_this_term: "Fetola lefoko le",
        fuzziness_label: "Tekanyo ya go tshwana:",
        statuses_label: "Maemo:",
        merge_all_exact: "Kopanya ditshwano tsotlhe tse di tshwanang ka botlalo ({{count}})",
        merge_all_exact_confirm: "Se se tla kopanya ditshwano tse di tshwanang ka botlalo tse {{count}}. Mo go nngwe le nngwe, e le nngwe e tla bolokwa mme e nngwe e phimolwa — se ga se kgone go fetolwa. Tswelela?",
        merge_all_exact_done: "Go kopantswe ditlhopha tse {{clusters}} tsa ditshwano tse di tshwanang ka botlalo ({{words}} di phimotswe).",
        merging: "E a kopanya…",
        close: "Tswala",
        request_needs_target_language: "Go kopa phetolelo, tlhopha puo e e rileng e o e lebisitseng mme o batle gape.",
        unverified: "Ga e ise e netefadiwe",
        notes: "Dintlha",
        show_notes: "Bontsha dintlha",
        hide_notes: "Fitlha dintlha",
        notes_hint: "Di bonala fela mo badirising ba ba tsenang.",
      },
    },
    ts: {
      translation: {
        word: "Rito",
        update_term: "Nkarhi wo pfuxeta",
        source: "Ririmi ra xihlovo",
        target: "Ririmi leri kongomisiweke",
        partial: "Ku fambisana ka xiphemu",
        fuzzy: "Pfumelela swihoxo swa ku pfala",
        enter: "Nghenisa rito ro lavisisa",
        terminology: "Hub ya Theminoloji",
        alllanguages: "Tindzimi hinkwato",
        search: "Secha",
        language: "Ririmi",
        context: "Vundzeni",
        add: "Engetela rito lerintshwa",
        advanced: "Ku lavisisa loku yaka emahlweni",
        accepted: "Ku amukeriwile",
        pending: "Rindzerile",
        rejected: "Ku ariwile",
        ACC: "Ku amukeriwile",
        PND: "Rindzerile",
        REJ: "Ku ariwile",
        status: "Xiyimo",
        translate_term: "Hundzuluxa rito",
        sourceword: "Rito ra xihlovo",
        translatedterm: "Rito leri hundzuluxeriweke",
        example: "Xikombiso",
        attribution: "Ku nyika xihlawuhlawu",
        newlanguage: "Ririmi lerintshwa",
        definition: "Nhlamuselo",
        school: "Xikolo",
        about: "Malunghana na hina",
        contact: "Tihlanganise na hina",
        user_manual: "Nkongomiso wa mutirhisi",
        addterm: "Engetelani rito",
        termdetail: "Vuxokoxoko bya theme",
        deleteconfirma: "Xana u tiyisile leswaku u lava ku susa '.",
        deleteconfirmb: "' na mongo ' .",
        deleteconfirmc: "' hi ririmi ' .",
        deleteconfirmd: "'?",
        yes: "Ina",
        no: "E-e",
        back: "Tlhelela",
        translate: "Hundzuluxa",
        update: "Pfuxeta",
        delete: "Sula",
        cancel: "Khansela",
        login: "Nghena",
        logout: "Huma",
        confirmlogout: "Tiyisa ku huma",
        register: "Tsarisa muchayeri",
        emailaddress: "Adirese ya imeyili",
        typeagain: "Tlanga adirese ya imeyili nakambe",
        surname: "Xivongo",
        firstname: "Vito ro sungula",
        username: "Vito ra muchayeri",
        password: "Phaswedi",
        message_username: "Vito ra muchayeri ri kona. Hlawula rin’wana.",
        message_email: "Imeriyili yi tsarisiwile. Tirhisa lembe rin’wana.",
        message_valid: "Adirese ya imeyili a yi lulamanga.",
        message_notsame: "Tiadirese ta imeyili a ti fani.",
        request_translation: "Komba ku hundzuluxiwa",
        submit_request: "Tshika xikombelo",
        term_not_found: "Rito a ri kumekanga",
        submitsuccess: "Xikombelo xi tshikiwile hi ku humelela!",
        theterm: "Rito ",
        notfound: " a ri kumekanga.",
        liketorequest: "Xana u lava ku kombela ku hundzuluxiwa?",
        suggest_translationa:
          "Xana u lava ku nyikela rito leri nga tolovelekangiki hi ",
        suggest_translationb: "?",
        ifsotype: "Loko swi ri tano, nghenisa laha:",
        notranslation: "A ku kumekangi ku hundzuluxiwa.",
        add_request: "Engetela rito leri kombiwaka",
        add_translation: "Engetela ku hundzuluxiwa",
        suggested_translation: "Ku hundzuluxiwa loku tshihiweke",
        date_requested: "Siku leri kombiweke",
        action: "Ntirho",
        no_requests: "A ku na swikombelo leswi kumekaka",
        r_user: "Muchayeri wa nkarhi hinkwawo",
        editor: "Muhundzuluxi",
        date_edited_label: "Yi cinciwe ro hetelela:",
        delete_a: "Sula A",
        delete_b: "Sula B",
        delete_word_confirm: "Sula '{{word}}'? Leswi a swi nge cinciwi.",
        administrator: "Mulawuri",
        requestlist: "Marito lawa kombiwaka",
        word_to_be_added: "Rito leri fanele ku engeteleriwa",
        pos: "Xiphemu xa ririmi",
        unknown: "A ku tiviwi",
        noun: "Vito",
        verb: "Rito ra ku endla",
        adjective: "Xiyila rito",
        pronoun: "Rito ro hlawula",
        adverb: "Xiyila rito ra ku endla",
        preposition: "Xiyila rito ra ndhawu",
        conjunction: "Xiyila rito ro hlanganisa",
        interjection: "Rito ra ku tshikilerisa",
        article: "Xiyila rito",
        suggests: "tshikisa",
        wiktionary_lookup: "Languta eka Wiktionary",
        actions: "Swiendlo",
        review_queue: "Nxaxamelo wo kambela",
        my_suggestions: "Switshuxo swa mina",
        missing_terms: "Marito lama nga kumekiki",
        duplicate_cleanup: "Ku basisa vuphindaphindani",
        english: "Xinghezi",
        submitted_by: "Xi rhumeriwe hi",
        days_pending: "Masiku lama rindzelaka",
        approve: "Pfumela",
        reject: "Ala",
        flag_action: "Fungha",
        previous: "Leswi hundzeke",
        next: "Leswi landzelaka",
        nothing_waiting_review: "A ku na leswi rindzelaka ku kambisisiwa.",
        showing_range: "Ku kombisa {{start}}–{{end}} eka {{total}}",
        you_havent_submitted: "A wu si rhumela marito ni rin'we.",
        target_language: "Ririmi leri kongomeriwaka:",
        nothing_missing: "A ku na leswi pfumalaka eka ririmi leri.",
        match_type: "Ku fana",
        word_a: "Rito A",
        word_b: "Rito B",
        english_reference_label: "Xinghezi (ntsena ku kombisa)",
        no_english_reference: "A ku na nomboro ya Xinghezi leyi kumekaka.",
        user_admin: "Vulawuri bya Vatirhisi",
        approver: "Mupfumeleri",
        role: "Xiave",
        change_role: "Cinca xiave",
        download_csv_template: "Khumba template ya CSV",
        upload_csv: "Tlulisa CSV",
        uploading: "Yi tlurisa...",
        upload_progress: "marito ya {{completed}} eka ya {{total}} ya tirhisiwile",
        upload_interrupted: "Ku nghenisa ku sirheletiwile endzhaku ka ya {{completed}} eka ya {{total}}. Nkombela u kambisisa vuyelo naswona u nghenisa nakambe tinllayini leti saleke loko swi laveka.",
        choose_csv_file: "Hlawula fayili ya CSV",
        bulk_upload_users: "Tlulisa vatirhisi vo tala hi nkarhi wun'we",
        bulk_upload_help: "Tlulisa fayili ya CSV ku endla vatirhisi vo tala hi nkarhi wun'we. Khumba template laha hansi ku sungula, ku tiyisisa leswaku fayili yi le ka fomati leyi faneleke.",
        temporary_password: "Phasiwedi ya nkarhinyana",
        temporary_password_notice: "Kopiya phasiwedi leyi sweswi u yi avelana na mutirhisi — a yi nge tlheli yi kombisiwa.",
        user_created: "Mutirhisi '{{username}}' u endliwile.",
        delete_user_confirm: "Sula mutirhisi '{{username}}'? Leswi a swi nge cinciwi.",
        csv_upload_results: "Vuyelo bya ku tlulisa",
        rows_created: "vatirhisi va {{count}} va endliwile",
        terms_created: "marito ya {{count}} ya ngheriseriwile",
        duplicate_warning_title: "Ku nghenisa loku nga fanaka",
        duplicate_warning_message: "Marito hinkwawo ya {{count}} eka fayili leyi se ma kona. Leswi swi languteka onge nkatalogo lowu fanaka wu nghenisiwa nakambe.",
        replace_previous_import: "Cinca ku nghenisa ka khale",
        add_in_any_case: "Nghenisa hambiloko swi ri tano",
        rows_skipped: "layini ta {{count}} ti hundziwile",
        row_label: "Layini",
        error_label: "Xihoxo",
        existing_users: "Vatirhisi lava nga ri kona",
        term_admin: "Vulawuri bya Marito",
        bulk_upload_terms: "Tlulisa marito yo tala hi nkarhi wun'we",
        bulk_upload_terms_help: "Tlulisa fayili ya CSV ku endla marito yo tala hi nkarhi wun'we, xikombiso ku suka enxaxamelweni lowu lulamisiweke kun'wana. Khumba template laha hansi ku sungula, ku tiyisisa leswaku fayili yi le ka fomati leyi faneleke.",
        export_terms: "Humesa marito",
        export_terms_help: "Humesa marito lama hlungiweke laha hansi ku ya efayilini ya CSV, ku katsa nsimu yin'wana ni yin'wana.",
        export_csv: "Humesa CSV",
        exporting: "Yi humesa...",
        keep_a_merge_b: "Hlayisa A, hlanganisa B",
        keep_b_merge_a: "Hlayisa B, hlanganisa A",
        not_a_duplicate: "A hi ku phindhaphindha",
        no_duplicates_found: "A ku kumekanga leswi phindhaphindhaka kumbe ku hambana.",
        filter_language: "Ririmi:",
        filter_submitted_by: "Xi rhumeriwe hi:",
        filter: "Hlela",
        clear_filters: "Susa switlhelo",
        all_languages_filter: "Tindzimi hinkwato",
        term_added: "'{{word}}' ri ri ngherisile naswona ri rindzela ku kambisisiwa.",
        add_another_term: "Engetela rito rin'wana",
        edit_this_term: "Cinca rito leri",
        fuzziness_label: "Xiyimo xa ku fana:",
        statuses_label: "Swiyimo:",
        merge_all_exact: "Hlanganisa ku fana hinkwako loku hetisekeke ({{count}})",
        merge_all_exact_confirm: "Leswi swi ta hlanganisa ku fana loku hetisekeke ka {{count}}. Eka yin'wana ni yin'wana, xin'we xi ta hlayisiwa lexin'wana xi susiwa — leswi a swi nge cinciwi. Ya emahlweni?",
        merge_all_exact_done: "Ku hlanganisiwe mintlawa ya {{clusters}} ya ku fana loku hetisekeke ({{words}} swi susiwile).",
        merging: "Yi ya hlanganisa…",
        close: "Pfala",
        request_needs_target_language: "Ku kombela vuhundzuluxeri, hlawula ririmi ro karhi leri u ri kongomisaka kutani u lavisisa nakambe.",
        unverified: "A yi si tiyisisiwa",
        notes: "Tinotsi",
        show_notes: "Kombisa tinotsi",
        hide_notes: "Fihla tinotsi",
        notes_hint: "Ti voniwa ntsena hi vatirhisi lava ngheneke.",
      },
    },
    ss: {
      translation: {
        word: "Livi",
        update_term: "Vuselela sikhatsi",
        source: "Lulwimi lwemtfombo",
        target: "Lulwimi loluhlosiwe",
        partial: "Umdlalo loyincenye",
        fuzzy: "Vumela emaphutsa wekupela",
        enter: "Faka ligama lekuphenya",
        terminology: "Sikhungo Semagama",
        alllanguages: "Tonkhe tilwimi",
        search: "Cinga",
        language: "Lulimi",
        context: "Umongo",
        add: "Ngeta ligama lelisha",
        advanced: "Luphenyo lolutfutfukile",
        accepted: "Kwemukelwe",
        pending: "Lokulindzelwe",
        rejected: "Kulahliwe",
        ACC: "Kwemukelwe",
        PND: "Lokulindzelwe",
        REJ: "Kulahliwe",
        status: "Sikhundla",
        translate_term: "Humusha ligama",
        sourceword: "Ligama lemtfombo",
        translatedterm: "Ligama lelihunyushiwe",
        example: "Sibonelo",
        attribution: "Kuniketwa",
        newlanguage: "Lulwimi lolusha",
        definition: "Incazelo",
        school: "Sikolwa",
        about: "Ngatsi",
        contact: "Xhumana natsi",
        user_manual: "Sicwayiso semsebentisi",
        addterm: "Ngeta ligama",
        termdetail: "Imininingwane yethemu",
        deleteconfirma: "Ucinisekile yini kutsi ufuna kucisha '",
        deleteconfirmb: "' ngesimo '",
        deleteconfirmc: "' ngelulwimi '",
        deleteconfirmd: "'?",
        yes: "Yebo",
        no: "Cha",
        back: "Ngemuva",
        translate: "Humusha",
        update: "Lungisa",
        delete: "Ususe",
        cancel: "Ungakwenti",
        login: "Ngena",
        logout: "Phuma",
        confirmlogout: "Qinisekisa ukuphuma",
        register: "Bhalisa umsebenzisi",
        emailaddress: "Ikheli le-imeyili",
        typeagain: "Faka ikheli le-imeyili futsi",
        surname: "Sibongo",
        firstname: "Ligama lokucala",
        username: "Ligama lomsebenzisi",
        password: "Iphasiwedi",
        message_username:
          "Ligama lomsebenzisi selivele likhona. Khetha lelinye.",
        message_email: "I-imeyili isivele ibhalisiwe. Sebentisa lelinye.",
        message_valid: "Ikheli le-imeyili alilungile.",
        message_notsame: "Tikhala le-imeyili atifani.",
        request_translation: "Cela kuhumusha",
        submit_request: "Faka sicelo",
        term_not_found: "Livi alikatalwa",
        submitsuccess: "Sicelo sifakwe ngempumelelo!",
        theterm: "Livi ",
        notfound: " alikatalwa.",
        liketorequest: "Ungatsandza kucela kuhumusha?",
        suggest_translationa:
          "Utsandza yini kuphakamisa livi lelingaba khona ngesi ",
        suggest_translationb: "?",
        ifsotype: "Nangabe kunjalo, faka lapha:",
        notranslation: "Akukatalwa kuhumusha.",
        add_request: "Engeta livi lecelo",
        add_translation: "Engeta kuhumusha",
        suggested_translation: "Kuhumusha lokuphakanyisiwe",
        date_requested: "Lilanga leceliwe ngalo",
        action: "Sisebenti",
        no_requests: "Akukatalwa sicelo",
        r_user: "Umsebenzisi lomtali",
        editor: "Umhleli",
        date_edited_label: "Kulungisiwe kwekugcina:",
        delete_a: "Ususe A",
        delete_b: "Ususe B",
        delete_word_confirm: "Ususe '{{word}}'? Loku angeke kubuyiselwe.",
        administrator: "Mphatsi",
        requestlist: "Magama laceliwe",
        word_to_be_added: "Livi lelitawungeziwe",
        pos: "Ingxenye yesigaba solwimi",
        unknown: "Akwatiwa",
        noun: "Libito",
        verb: "Senzamndla",
        adjective: "Isiphawulo",
        pronoun: "Libito lesikhulumi",
        adverb: "Isandziso",
        preposition: "Isikhundla",
        conjunction: "Lihlanganisi",
        interjection: "Kuphakanyiso",
        article: "Isihloko",
        suggests: "uphakamisa",
        wiktionary_lookup: "Buka ku-Wiktionary",
        actions: "Tenzo",
        review_queue: "Luhlu lekuhlola",
        my_suggestions: "Tincomo tami",
        missing_terms: "Emagama langekho",
        duplicate_cleanup: "Kucacisa lokuphindziwe",
        english: "SiNgisi",
        submitted_by: "Kutfunyelwe ngu",
        days_pending: "Emalanga lalindzile",
        approve: "Vuma",
        reject: "Yenaba",
        flag_action: "Phawula",
        previous: "Lokwendlulile",
        next: "Lokulandzelako",
        nothing_waiting_review: "Akukho lokulindzele kubuyeketa.",
        showing_range: "Kukhomba {{start}}–{{end}} kuya ku-{{total}}",
        you_havent_submitted: "Awukafaki nawuphi emagama.",
        target_language: "Lulwimi lolucondziwe:",
        nothing_missing: "Akukho lokushodzako kulolu lulwimi.",
        match_type: "Kufana",
        word_a: "Ligama A",
        word_b: "Ligama B",
        english_reference_label: "SiNgisi (kuphela njengesikhombakhombisi)",
        no_english_reference: "Ayikho i-inchi yesiNgisi leyitfoliwe.",
        user_admin: "Kuphatfwa Kwebasebentisi",
        approver: "Umvumeli",
        role: "Indzima",
        change_role: "Shintja indzima",
        download_csv_template: "Layisha i-template ye-CSV",
        upload_csv: "Layisha i-CSV",
        uploading: "Iyalayisha...",
        upload_progress: "emagama lama-{{completed}} kuma-{{total}} lasetjentiswe",
        upload_interrupted: "Kufaka kuphazanyisiwe ngemuva kwe-{{completed}} kuma-{{total}}. Sicela uhlole imiphumela bese uphindza ufake imigca leseleko nangabe kuyadzingeka.",
        choose_csv_file: "Khetsa lifayela le-CSV",
        bulk_upload_users: "Layisha bantfu labanyenti ngasikhatsi sinye",
        bulk_upload_help: "Layisha lifayela le-CSV kwakha bantfu labanyenti ngasikhatsi sinye. Layisha i-template ngentasi kucala, kucinisekisa kutsi lifayela likulo lifomu lelifanele.",
        temporary_password: "Liphasiwedi lesikhashana",
        temporary_password_notice: "Kopisha leliphasiwedi manje futsi wabelane nemsebentisi — angeke liphindze liboniswe.",
        user_created: "Umsebentisi '{{username}}' wakhiwe.",
        delete_user_confirm: "Ususe umsebentisi '{{username}}'? Loku angeke kubuyiselwe.",
        csv_upload_results: "Imiphumela yekulayisha",
        rows_created: "bemsebentisi laba-{{count}} bakhiwe",
        terms_created: "emagama lama-{{count}} lafakiwe",
        duplicate_warning_title: "Kufaka lokungasho kuphindze",
        duplicate_warning_message: "Onkhe emagama lama-{{count}} kulelifayela asekhona. Loku kubonakala shengatsi luhlu lolufanako luyafakwa futsi.",
        replace_previous_import: "Shintja kufaka kwangaphambilini",
        add_in_any_case: "Faka noma kunjalo",
        rows_skipped: "emalayini la-{{count}} adluliwe",
        row_label: "Layini",
        error_label: "Liphutsa",
        existing_users: "Bantfu labasebasho bakhona",
        term_admin: "Kuphatfwa Kwemagama",
        bulk_upload_terms: "Layisha emagama lamanyenti ngasikhatsi sinye",
        bulk_upload_terms_help: "Layisha lifayela le-CSV kwakha emagama lamanyenti ngasikhatsi sinye, sibonelo kuhlelo lolwakhiwe kunye indzawo. Layisha i-template ngentasi kucala, kucinisekisa kutsi lifayela likulo lifomu lelifanele.",
        export_terms: "Tfumela emagama ngephandle",
        export_terms_help: "Tfumela emagama lahlungiwe ngentasi ngephandle kulifayela le-CSV, kufaka onkhe emasimu.",
        export_csv: "Tfumela i-CSV ngephandle",
        exporting: "Iyatfumela ngephandle...",
        keep_a_merge_b: "Gcina A, hlanganisa B",
        keep_b_merge_a: "Gcina B, hlanganisa A",
        not_a_duplicate: "Akusiyo lekuphindzwe",
        no_duplicates_found: "Kute lokuphindziwe nobe lokuphikisana lokutfolakele.",
        filter_language: "Lulwimi:",
        filter_submitted_by: "Kutfunyelwe ngu:",
        filter: "Hlunga",
        clear_filters: "Sula tihlungi",
        all_languages_filter: "Tonkhe tilwimi",
        term_added: "'{{word}}' beke wefakwa futsi ulindzele kubuyeketwa.",
        add_another_term: "Faka lelinye ligama",
        edit_this_term: "Hlela leli gama",
        fuzziness_label: "Emkhawulo wekufana:",
        statuses_label: "Tikhundla:",
        merge_all_exact: "Hlanganisa konkhe lokufana ngalokuphelele ({{count}})",
        merge_all_exact_confirm: "Loku kutawuhlanganisa kufana lokuphelele lokungu-{{count}}. Kunye nakunye, lokunye kutawugcinwa lokunye kususwe — loku angeke kubuyiselwe. Chubeka?",
        merge_all_exact_done: "Kuhlanganisiwe emacembu langu-{{clusters}} ekufana lokuphelele (lokungu-{{words}} kususiwe).",
        merging: "Iyahlanganisa…",
        close: "Vala",
        request_needs_target_language: "Kute ucele kuhumusha, khetsa lulwimi lolutsite lolubhekiswe kulo bese uyasesha futsi.",
        unverified: "Akukacinisekiswa",
        notes: "Emanothi",
        show_notes: "Khombisa emanothi",
        hide_notes: "Fihla emanothi",
        notes_hint: "Kubonakala kuphela kubasebentisi labangenile.",
      },
    },
    nr: {
      translation: {
        word: "Ilizwi",
        update_term: "Buyisela ilizwi",
        source: "Ulwimi lwemvelaphi",
        target: "Ulwimi okuya kulo",
        partial: "Ukufana ngesigaba",
        fuzzy: "Vumela amaphosiso wokupela",
        enter: "Faka ilizwi lokucwaninga",
        terminology: "Isikhungo Samagama",
        alllanguages: "Zonke izilimi",
        allstatus: "Zonke izimo",
        search: "Cwaninga",
        language: "Ulwimi",
        context: "Umsuka",
        add: "Engeza ilizwi elitsha",
        advanced: "Ukucwaninga okujulile",
        accepted: "Kuvunyiwe",
        pending: "Kulindwe",
        rejected: "Kwaliwe",
        flagged: "Kuphawuliwe",
        ACC: "Kuvunyiwe",
        PND: "Kulindwe",
        REJ: "Kwaliwe",
        FLG: "Kuphawuliwe",
        status: "Isimo",
        translate_term: "Humusha ilizwi",
        sourceword: "Ilizwi lomthombo",
        translatedterm: "Ilizwi elihunyushwe",
        example: "Isibonelo",
        attribution: "Ukubongwa",
        newlanguage: "Ulwimi olusha",
        definition: "Incazelo",
        school: "Isikolo",
        about: "Ngathi",
        contact: "Thintana nathi",
        user_manual: "Incwadi yomsebenzisi",
        addterm: "Engeza ilizwi",
        termdetail: "Imininingwane yelizwi",
        deleteconfirma: "Uqinisekile ukuthi ufuna ukususa '",
        deleteconfirmb: "' ngekonteksti '",
        deleteconfirmc: "' ngolimi lwe '",
        deleteconfirmd: "'?",
        yes: "Yebo",
        no: "Hayi",
        back: "Buyela emuva",
        translate: "Humusha",
        update: "Buyisela",
        delete: "Susa",
        cancel: "Khansela",
        login: "Ngena",
        logout: "Phuma",
        confirmlogout: "Qinisekisa ukuphuma",
        register: "Bhalisa umsebenzisi",
        emailaddress: "Ikheli le-imeyili",
        typeagain: "Faka ikheli le-imeyili futhi",
        surname: "Isibongo",
        firstname: "Igama lokuqala",
        username: "Igama lomsebenzisi",
        password: "Iphasiwedi",
        message_username: "Igama lomsebenzisi selikhona. Khetha elinye.",
        message_email: "I-imeyili isivele ibhalisiwe. Sebenzisa enye.",
        message_valid: "Ikheli le-imeyili alilungile.",
        message_notsame: "Amakheli e-imeyili awafani.",
        request_translation: "Cela ukuhumusha",
        submit_request: "Faka isicelo",
        term_not_found: "Ilizwi alitholakalanga",
        submitsuccess: "Isicelo sifakwe ngempumelelo!",
        theterm: "Ilizwi ",
        notfound: " alitholakalanga.",
        liketorequest: "Ungathanda ukucela ukuhumusha?",
        suggest_translationa: "Ufuna ukuphakamisela elinye ilizwi ngesi ",
        suggest_translationb: "?",
        ifsotype: "Uma kunjalo, faka lapha:",
        notranslation: "Awekho amagama ahunyushwe atholakele.",
        add_request: "Engeza ilizwi eliceliwe",
        add_translation: "Engeza ukuhumusha",
        suggested_translation: "Ukuhumusha okuphakanyisiwe",
        date_requested: "Usuku lokucela",
        action: "Isenzo",
        no_requests: "Awekho amacala atholakele",
        r_user: "Umsebenzisi ojwayelekile",
        editor: "Umhleli",
        date_edited_label: "Kulungiswe kokugcina:",
        delete_a: "Susa A",
        delete_b: "Susa B",
        delete_word_confirm: "Susa '{{word}}'? Lokhu akukghoni ukubuyiselwa.",
        administrator: "Umphathi",
        requestlist: "Amagama aceliwe",
        word_to_be_added: "Ilizwi elizongezwa",
        pos: "Ingxenye yolimi",
        unknown: "Akukaziwa",
        noun: "Ibizo",
        verb: "Isenzo",
        adjective: "Isiphawulo",
        pronoun: "Isabizwana",
        adverb: "Isandiso",
        preposition: "Isandiso sendawo",
        conjunction: "Isihlanganiso",
        interjection: "Izibonakaliso",
        article: "Isihloko",
        suggests: "uphakamisela",
        wiktionary_lookup: "Qala ku-Wiktionary",
        actions: "Izenzo",
        review_queue: "Uhlu lokubuyekeza",
        my_suggestions: "Iimcabango zami",
        missing_terms: "Amagama alahlekileko",
        duplicate_cleanup: "Ukususa okuphindiweko",
        english: "IsiNgisi",
        submitted_by: "Kuthunyelwe ngu",
        days_pending: "Amalanga alindile",
        approve: "Vuma",
        reject: "Yenqaba",
        flag_action: "Phawula",
        previous: "Okwedlule",
        next: "Okulandelako",
        nothing_waiting_review: "Akukho okulindele ukubuyekezwa.",
        showing_range: "Kutjengiswa u-{{start}}–{{end}} kwaku-{{total}}",
        you_havent_submitted: "Awukafaki nanyana ngimuphi amagama.",
        target_language: "Ilimi elikhethiweko:",
        nothing_missing: "Akukho okutlhogekako kilelilimi.",
        match_type: "Ukufana",
        word_a: "Ibizo A",
        word_b: "Ibizo B",
        english_reference_label: "IsiNgisi (kuphela sokubhekisela)",
        no_english_reference: "Akukho ingeniso yesiNgisi etholakeleko.",
        user_admin: "Ukulawulwa Kwabasebenzisi",
        approver: "Umvumeli",
        role: "Indima",
        change_role: "Tjhugulula indima",
        download_csv_template: "Layisha i-template ye-CSV",
        upload_csv: "Layisha i-CSV",
        uploading: "Iyalayisha...",
        upload_progress: "amabizo ama-{{completed}} kuma-{{total}} asetjenzisiwe",
        upload_interrupted: "Ukufaka kuphazanyisiwe ngemva kwe-{{completed}} kuma-{{total}}. Sicela uhlole imiphumela bese ufaka godu imigca esele nangabe kuyatlhogeka.",
        choose_csv_file: "Khetha ifayela le-CSV",
        bulk_upload_users: "Layisha abasebenzisi abanengi ngasikhathi sinye",
        bulk_upload_help: "Layisha ifayela le-CSV bona wakhe abasebenzisi abanengi ngasikhathi sinye. Layisha i-template ngezasi kuthoma, ukuqinisekisa bona ifayela isefomeni elifaneleko.",
        temporary_password: "Iphasiwedi yesikhatjhana",
        temporary_password_notice: "Kopisha le phasiwedi nje bese uyabelana nomsebenzisi — akusayi kutjhwenywa godu.",
        user_created: "Umsebenzisi '{{username}}' wakhiwe.",
        delete_user_confirm: "Susa umsebenzisi '{{username}}'? Lokhu akukghoni ukubuyiselwa.",
        csv_upload_results: "Imiphumela yokulayisha",
        rows_created: "abasebenzisi aba-{{count}} bakhiwe",
        terms_created: "amabizo ama-{{count}} arholiwe",
        duplicate_warning_title: "Ukufaka okungenzeka kuphindiwe",
        duplicate_warning_message: "Woke amabizo ama-{{count}} kwelifayela seli kade akhona. Lokhu kubonakala kwanga uhlu olufanako luyafakwa godu.",
        replace_previous_import: "Tjhugulula ukufaka kwangaphambili",
        add_in_any_case: "Faka nanyana kunjalo",
        rows_skipped: "amalayini a-{{count}} adluliwe",
        row_label: "Ilayini",
        error_label: "Iphosiso",
        existing_users: "Abasebenzisi asebakhona",
        term_admin: "Ukulawulwa Kwamabizo",
        bulk_upload_terms: "Layisha amabizo amanengi ngasikhathi sinye",
        bulk_upload_terms_help: "Layisha ifayela le-CSV bona wakhe amabizo amanengi ngasikhathi sinye, isibonelo kuhlu olwenziwe kwenye indawo. Layisha i-template ngezasi kuthoma, ukuqinisekisa bona ifayela isefomeni elifaneleko.",
        export_terms: "Thumela amabizo ngaphandle",
        export_terms_help: "Thumela amabizo ahlungiweko ngezasi ngaphandle kwelifayela le-CSV, kufaka woke amasimu.",
        export_csv: "Thumela i-CSV ngaphandle",
        exporting: "Iyathumela ngaphandle...",
        keep_a_merge_b: "Gcina A, hlanganisa B",
        keep_b_merge_a: "Gcina B, hlanganisa A",
        not_a_duplicate: "Akusiyo ephindiweko",
        no_duplicates_found: "Akukho okuphindiweko namkha okuphikisanako okutholakeleko.",
        filter_language: "Ilimi:",
        filter_submitted_by: "Kuthunyelwe ngu:",
        filter: "Hlungela",
        clear_filters: "Sula iihlungi",
        all_languages_filter: "Woke amalimi",
        term_added: "'{{word}}' irholiwe begodu ilindile ukubuyekezwa.",
        add_another_term: "Faka elinye ibizo",
        edit_this_term: "Hlela leli bizo",
        fuzziness_label: "Izinga lokufana:",
        statuses_label: "Izimo:",
        merge_all_exact: "Hlanganisa koke okufana ngokupheleleko ({{count}})",
        merge_all_exact_confirm: "Lokhu kuzokuhlanganisa ukufana ngokupheleleko okungu-{{count}}. Kokubili, okunye kuzokugcinwa okunye kususwe — lokhu akukghoni ukubuyiselwa. Qhubeka?",
        merge_all_exact_done: "Kuhlanganiswe amaqoqo angu-{{clusters}} wokuphindiweko (okungu-{{words}} kususiwe).",
        merging: "Iyahlanganisa…",
        close: "Vala",
        request_needs_target_language: "Bona ubawe ukutjhugululwa, khetha ilimi elithileko bese uyafuna godu.",
        unverified: "Akukaqinisekiswa",
        notes: "Amanothi",
        show_notes: "Tjengisa amanothi",
        hide_notes: "Fihla amanothi",
        notes_hint: "Kubonakala kwaphela kubasebenzisi abangeneko.",
      },
    },
    xh: {
      translation: {
        word: "Ilizwi",
        update_term: "Hlaziya ixesha",
        source: "Ulwimi lwentsusa",
        target: "Ulwimi ekujoliswe kulo",
        partial: "Umdlalo ongaphelelanga",
        fuzzy: "Vumela iimpazamo zopelo",
        enter: "Ngenisa igama lokukhangela",
        terminology: "IZiko lesigama",
        alllanguages: "Zonke iilwimi",
        search: "Khangela",
        language: "Ulwimi",
        context: "Umxholo",
        add: "Yongeza igama elitsha",
        advanced: "Ukhangelo olunzulu",
        accepted: "Yamkelwe",
        pending: "Ilindile",
        rejected: "Yaliwe",
        ACC: "Yamkelwe",
        PND: "Ilindile",
        REJ: "Yaliwe",
        status: "Ubume",
        translate_term: "Guqulela ixesha",
        sourceword: "Ixesha lomthombo",
        translatedterm: "Ixesha eliguqulelweyo",
        example: "Umzekelo",
        attribution: "Unikezelo",
        newlanguage: "Ulwimi olutsha",
        definition: "Ingcaciso",
        school: "Isikolo",
        about: "Ngathi",
        contact: "Qhagamshelana nathi",
        user_manual: "Incwadi yomsebenzisi",
        addterm: "Yongeza ixesha",
        termdetail: "Iinkcukacha zexesha",
        deleteconfirma: "Uqinisekile ufuna ukucima '",
        deleteconfirmb: "' ngomxholo'",
        deleteconfirmc: "' ngolwimi'",
        deleteconfirmd: "'?",
        yes: "Ewe",
        no: "Hayi",
        back: "Emva",
        translate: "Guqulela",
        update: "Hlaziya",
        delete: "Cima",
        cancel: "Rhoxisa",
        login: "Ngena",
        logout: "Phuma",
        confirmlogout: "Qinisekisa ukuphuma",
        register: "Bhalisa umsebenzisi",
        emailaddress: "Idilesi ye-imeyili",
        typeagain: "Faka kwakhona idilesi ye-imeyili",
        surname: "Ifani",
        firstname: "Igama lokuqala",
        username: "Igama lomsebenzisi",
        password: "Iphasiwedi",
        message_username: "Igama lomsebenzisi selikhona. Khetha elinye.",
        message_email: "Le imeyili sele ibhalisiwe. Sebenzisa enye.",
        message_valid: "Idilesi ye-imeyili ayilunganga.",
        message_notsame: "Iidilesi ze-imeyili azifani.",
        request_translation: "Cela uguqulelo",
        submit_request: "Ngenisa isicelo",
        term_not_found: "Igama alifumanekanga",
        submitsuccess: "Isicelo singeniswe ngempumelelo!",
        theterm: "Igama ",
        notfound: " alifumanekanga.",
        liketorequest: "Ungathanda ukucela uguqulelo?",
        suggest_translationa: "Ngaba ungathanda ukuphakamisa igama elinokubakho ngesi ",
        suggest_translationb: "?",
        ifsotype: "Ukuba kunjalo, ngenisa apha:",
        notranslation: "Akukho guqulelo lifunyenweyo.",
        add_request: "Yongeza igama elicelwayo",
        add_translation: "Yongeza uguqulelo",
        suggested_translation: "Uguqulelo oluphakanyisiweyo",
        date_requested: "Umhla oceliwe",
        action: "Isenzo",
        no_requests: "Akukho zicelo zifunyenweyo",
        r_user: "Umsebenzisi oqhelekileyo",
        editor: "Umhleli",
        date_edited_label: "Ihleliwe okokugqibela:",
        delete_a: "Cima A",
        delete_b: "Cima B",
        delete_word_confirm: "Cima '{{word}}'? Oku akunakuguqulwa.",
        administrator: "Umphathi",
        requestlist: "Amagama acelwayo",
        word_to_be_added: 'Igama eliza kongezwa',
        pos: "Inxalenye yolwimi",
        unknown: "Akukaziwa",
        noun: "Isibizo",
        verb: "Isenzi",
        adjective: "Isiphawuli",
        pronoun: "Isabizwana",
        adverb: "Isihlomelo",
        preposition: "Isihlanganisi sendawo",
        conjunction: "Isihlanganisi",
        interjection: "Isimamezelo",
        article: "Inqaku",
        suggests: "uphakamisa",
        wiktionary_lookup: "Jonga kwiWiktionary",
        actions: "Izenzo",
        review_queue: "Uluhlu lophononongo",
        my_suggestions: "Iingcebiso zam",
        missing_terms: "Amagama alahlekileyo",
        duplicate_cleanup: "Ukususa okuphindiweyo",
        english: "IsiNgesi",
        submitted_by: "Ithunyelwe ngu",
        days_pending: "Iintsuku ezilindileyo",
        approve: "Vuma",
        reject: "Yala",
        flag_action: "Phawula",
        previous: "Okudlulileyo",
        next: "Okulandelayo",
        nothing_waiting_review: "Akukho nto ilindele uphononongo.",
        showing_range: "Ibonisa u-{{start}}–{{end}} kokungu-{{total}}",
        you_havent_submitted: "Awukafaki nawaphi na amagama okwangoku.",
        target_language: "Ulwimi olujoliswe kulo:",
        nothing_missing: "Akukho nto ingekhoyo kolu lwimi.",
        match_type: "Ukufana",
        word_a: "Igama A",
        word_b: "Igama B",
        english_reference_label: "IsiNgesi (kuphela ukubhekisela)",
        no_english_reference: "Akukho ngeniso yesiNgesi ifunyenweyo.",
        user_admin: "Ulawulo Lwabasebenzisi",
        approver: "Umvumeli",
        role: "Indima",
        change_role: "Tshintsha indima",
        download_csv_template: "Khuphela itempleyithi ye-CSV",
        upload_csv: "Layisha i-CSV",
        uploading: "Iyalayisha...",
        upload_progress: "amagama ama-{{completed}} kuma-{{total}} enziwe",
        upload_interrupted: "Ukufaka kuphazanyiswe emva kwe-{{completed}} kuma-{{total}}. Nceda ujonge iziphumo uze ufake kwakhona imigca eseleyo xa kufuneka.",
        choose_csv_file: "Khetha ifayile ye-CSV",
        bulk_upload_users: "Layisha abasebenzisi abaninzi ngexesha elinye",
        bulk_upload_help: "Layisha ifayile ye-CSV ukwenza abasebenzisi abaninzi ngexesha elinye. Khuphela itempleyithi ngezantsi kuqala, ukuqinisekisa ukuba ifayile ikwifomathi echanekileyo.",
        temporary_password: "Iphasiwedi yexeshana",
        temporary_password_notice: "Kopa le phasiwedi ngoku uze uyabelane nomsebenzisi — ayisayi kubonakaliswa kwakhona.",
        user_created: "Umsebenzisi '{{username}}' wenziwe.",
        delete_user_confirm: "Cima umsebenzisi '{{username}}'? Oku akunakuguqulwa.",
        csv_upload_results: "Iziphumo zokulayisha",
        rows_created: "abasebenzisi aba-{{count}} benziwe",
        terms_created: "amagama ama-{{count}} adityaniswe",
        duplicate_warning_title: "Ukufaka okusenokuphindwa",
        duplicate_warning_message: "Onke amagama ama-{{count}} kule fayile sele ekho. Oku kubonakala ngathi olu luhlu lufanayo luyafakwa kwakhona.",
        replace_previous_import: "Buyisela ukufaka kwangaphambili",
        add_in_any_case: "Faka nakuba kunjalo",
        rows_skipped: "imigca eli-{{count}} idluliwe",
        row_label: "Umgca",
        error_label: "Impazamo",
        existing_users: "Abasebenzisi abasele bekho",
        term_admin: "Ulawulo Lwamagama",
        bulk_upload_terms: "Layisha amagama amaninzi ngexesha elinye",
        bulk_upload_terms_help: "Layisha ifayile ye-CSV ukwenza amagama amaninzi ngexesha elinye, umzekelo kuluhlu olulungiselelwe kwenye indawo. Khuphela itempleyithi ngezantsi kuqala, ukuqinisekisa ukuba ifayile ikwifomathi echanekileyo.",
        export_terms: "Thumela amagama ngaphandle",
        export_terms_help: "Thumela amagama ahluziweyo ngezantsi ngaphandle kwifayile ye-CSV, kubandakanya yonke intsimi.",
        export_csv: "Thumela i-CSV ngaphandle",
        exporting: "Iyathumela ngaphandle...",
        keep_a_merge_b: "Gcina A, dibanisa B",
        keep_b_merge_a: "Gcina B, dibanisa A",
        not_a_duplicate: "Ayisiyo ephindiweyo",
        no_duplicates_found: "Akukho kuphindwa okanye ungquzulwano olufunyenweyo.",
        filter_language: "Ulwimi:",
        filter_submitted_by: "Ithunyelwe ngu:",
        filter: "Hlunga",
        clear_filters: "Sula izihluzi",
        all_languages_filter: "Zonke iilwimi",
        term_added: "'{{word}}' idityaniswe kwaye ilindele uphononongo.",
        add_another_term: "Yongeza elinye igama",
        edit_this_term: "Hlela eli gama",
        fuzziness_label: "Umlinganiselo wokufana:",
        statuses_label: "Iimeko:",
        merge_all_exact: "Dibanisa konke okufana ngokupheleleyo ({{count}})",
        merge_all_exact_confirm: "Oku kuza kudibanisa ukufana okupheleleyo okungu-{{count}}. Kwelinye nelinye, enye izakugcinwa enye icinywe — oku akunakuguqulwa. Qhubeka?",
        merge_all_exact_done: "Kudityaniswe amaqela angu-{{clusters}} okuphindwa okupheleleyo (okungu-{{words}} kucinyiwe).",
        merging: "Iyadibanisa…",
        close: "Vala",
        request_needs_target_language: "Ukucela uguqulelo, khetha ulwimi ekujoliswe kulo oluthile uze ukhangele kwakhona.",
        unverified: "Akuqinisekiswanga",
        notes: "Amanqaku",
        show_notes: "Bonisa amanqaku",
        hide_notes: "Fihla amanqaku",
        notes_hint: "Abonakala kuphela kubasebenzisi abangenileyo.",
      },
    },
    ve: {
      translation: {
        word: "Ipfi",
        update_term: "Themo ya u khwinisa",
        source: "Luambo lwa tshisima",
        target: "Luambo lwo livhiswaho",
        partial: "Mutambo wa tshipiḓa",
        fuzzy: "Tendela phoxo dza u fara",
        enter: "Ṅwalani themo ya ṱhoḓisiso",
        terminology: "Hub ya Theminolodzhi",
        alllanguages: "Nyambo dzothe .",
        search: "Ṱoḓa",
        language: "Luambo",
        context: "Tsiangane",
        add: "Kha vha engedze themo ntswa",
        advanced: "U ṱoḓa ha nṱhesa",
        accepted: "Zwo ṱanganedzwa",
        pending: "Shumisa",
        rejected: "Ho landulwa",
        ACC: "Zwo ṱanganedzwa",
        PND: "Shumisa",
        REJ: "Ho landulwa",
        status: "Tshiimo",
        translate_term: "Kha vha ṱalutshedzele themo",
        sourceword: "Themo ya tshisima",
        translatedterm: "Themo yo ṱalutshedzelwaho",
        example: "Tsumbo",
        attribution: "U ṋea vhuṱanzi",
        newlanguage: "Luambo luswa .",
        definition: "Ṱhalutshedzo",
        school: "Tshikolo",
        about: "Nga ha rine .",
        contact: "Kha vha ri kwame",
        user_manual: "Buga ya mushumisi",
        addterm: "Engedza themo",
        termdetail: "Zwidodombedzwa zwa themo",
        deleteconfirma: "Ni na vhutanzi uri ni khou toda u phumula ' .",
        deleteconfirmb: "' na vhubvo '",
        deleteconfirmc: "' kha luambo ' .",
        deleteconfirmd: "'?",
        yes: "Ee",
        no: "Hai",
        back: "Murahu",
        translate: "Phindulela",
        update: "Khwiniso",
        delete: "Thutha",
        cancel: "Khansela",
        login: "Ngena",
        logout: "Phuma",
        confirmlogout: "Qinisekisa ukuphuma",
        register: "Bhalisa umsebenzisi",
        emailaddress: "Idilesi ye-imeyili",
        typeagain: "Faka kwakhona idilesi ye-imeyili",
        surname: "Ifani",
        firstname: "Igama lokuqala",
        username: "Igama lomsebenzisi",
        password: "Iphasiwedi",
        message_username: "Igama lomsebenzisi selikhona. Khetha elinye.",
        message_email: "I-imeyili isivele ibhalisiwe. Sebenzisa enye.",
        message_valid: "Idilesi ye-imeyili ayilunganga.",
        message_notsame: "Iidilesi ze-imeyili azifani.",
        request_translation: "Cela uguqulelo",
        submit_request: "Ngenisa isicelo",
        term_not_found: "Nḓivho i sa funi",
        submitsuccess: "Isicelo singeniswe ngempumelelo!",
        theterm: "Nḓivho ",
        notfound: " i sa funi.",
        liketorequest: "Ungathanda ukucela uguqulelo?",
        suggest_translationa: "Ngaba ungathanda ukuphakamisa nḓivho elinokubakho ngesi ",
        suggest_translationb: "?",
        ifsotype: "Ukuba kunjalo, ngenisa apha:",
        notranslation: "Awekho amagama ahunyushwe atholakele.",
        add_request: "Yongeza nḓivho elicelwayo",
        add_translation: "Yongeza uguqulelo",
        suggested_translation: "Uguqulelo oluphakanyisiweyo",
        date_requested: "Usuku lokucela",
        action: "Isenzo",
        no_requests: "Awekho amacala atholakele",
        r_user: "Umsebenzisi ojwayelekile",
        editor: "Umhleli",
        date_edited_label: "Yo khwinisiwa lwa vhufhelo:",
        delete_a: "Thutha A",
        delete_b: "Thutha B",
        delete_word_confirm: "Thutha '{{word}}'? Hezwi a zwi koneli u shanduka.",
        administrator: "Umphathi",
        requestlist: "Amagama aceliwe",
        word_to_be_added: 'Nḓivho i ḓo nyadzwa',
        pos: "Ingxenye yolwimi",
        unknown: "Akwatiwa",
        noun: "Ibizo",
        verb: "Isenzo",
        adjective: "Isiphawulo",
        pronoun: "Isabizwana",
        adverb: "Isandiso",
        preposition: "Isikhundla",
        conjunction: "Lihlanganisi",
        interjection: "Kuphakanyiso",
        article: "Isihloko",
        suggests: "uphakamisa",
        wiktionary_lookup: "Sedza kha Wiktionary",
        actions: "Zwiito",
        review_queue: "Kavhambo ya u sedza",
        my_suggestions: "Themendelo dzanga",
        missing_terms: "Maipfi a sa wanali",
        duplicate_cleanup: "U kuna zwo phindaho",
        english: "Isipiḻa",
        submitted_by: "Zwo rumelwa nga",
        days_pending: "Maḓuvha o lindelaho",
        approve: "Tenda",
        reject: "Hanedza",
        flag_action: "Sumbedza",
        previous: "Zwo fhelaho",
        next: "Zwi tevhelaho",
        nothing_waiting_review: "A hu na tshine tsha lindela u sedzwa.",
        showing_range: "I sumbedza {{start}}–{{end}} kha {{total}}",
        you_havent_submitted: "A tho ngo rumela maipfi na line.",
        target_language: "Luambo lu livhaho:",
        nothing_missing: "A hu na tshine tsha shaya kha luambo lu.",
        match_type: "U fana",
        word_a: "Ipfi A",
        word_b: "Ipfi B",
        english_reference_label: "Luisimane (ndi tsumbo fhedzi)",
        no_english_reference: "A hu na dzina ḽa Luisimane ḽo wanalaho.",
        user_admin: "Vhulanguli ha Vhashumisi",
        approver: "Mutendi",
        role: "Mushumo",
        change_role: "Shandula mushumo",
        download_csv_template: "Dzhenisa template ya CSV",
        upload_csv: "Isa CSV nntha",
        uploading: "Khou isa...",
        upload_progress: "maipfi a {{completed}} kha a {{total}} o shumiswa",
        upload_interrupted: "U dzhenisa ho kandeledzwa nga murahu ha a {{completed}} kha a {{total}}. Ri a kombelela sedzani mvelelo nahone ni dzhenise hafhu mirongo yo salaho arali zwi tea.",
        choose_csv_file: "Nangula faela ya CSV",
        bulk_upload_users: "Isa vhashumisi vhanzhi nga tshifhinga tshithihi",
        bulk_upload_help: "Isa faela ya CSV u sika vhashumisi vhanzhi nga tshifhinga tshithihi. Dzhenisani template afho fhasi u thoma, u khwaṱhisedza uri faela i kha fomethi yo teaho.",
        temporary_password: "Phasiwedi ya tshifhinganyana",
        temporary_password_notice: "Kopani heyi phasiwedi zwino ni i abelane na mushumisi — a i nga ḓo sumbedzwa hafhu.",
        user_created: "Mushumisi '{{username}}' o sikwa.",
        delete_user_confirm: "Thutha mushumisi '{{username}}'? Hezwi a zwi koneli u shanduka.",
        csv_upload_results: "Mvelelo dza u isa",
        rows_created: "vhashumisi vha {{count}} vho sikwa",
        terms_created: "maipfi a {{count}} o engedzwa",
        duplicate_warning_title: "U dzhenisa hune ha nga vha ho phindwa",
        duplicate_warning_message: "Maipfi oṱhe a {{count}} kha ifaela heyi o no vha hone. Zwenezwi zwi vhonala u nga luvhi lu fanaho lu khou dzheniswa hafhu.",
        replace_previous_import: "Shandukisa u dzhenisa ha kale",
        add_in_any_case: "Dzhenisa naho zwo ralo",
        rows_skipped: "mirongo ya {{count}} yo pfukiwa",
        row_label: "Murongo",
        error_label: "Vhukhakhi",
        existing_users: "Vhashumisi vho no vha hone",
        term_admin: "Vhulanguli ha Maipfi",
        bulk_upload_terms: "Isa maipfi manzhi nga tshifhinga tshithihi",
        bulk_upload_terms_help: "Isa faela ya CSV u sika maipfi manzhi nga tshifhinga tshithihi, tsumbo u bva kha bammbiri yo dzudzanywaho fhethu hunwe. Dzhenisani template afho fhasi u thoma, u khwaṱhisedza uri faela i kha fomethi yo teaho.",
        export_terms: "Bveisa maipfi",
        export_terms_help: "Bveisa maipfi o saliwaho afho fhasi u ya kha faela ya CSV, hu tshi katela ndango iṅwe na iṅwe.",
        export_csv: "Bveisa CSV",
        exporting: "Khou bveisa...",
        keep_a_merge_b: "Vulunga A, hangana na B",
        keep_b_merge_a: "Vulunga B, hangana na A",
        not_a_duplicate: "A si u phinda",
        no_duplicates_found: "A ho ngo wanala u phindaho kana u hanedzana.",
        filter_language: "Luambo:",
        filter_submitted_by: "Zwo rumelwa nga:",
        filter: "Sefa",
        clear_filters: "Bvisa zwisefo",
        all_languages_filter: "Nyambo dzothe",
        term_added: "'{{word}}' yo engedzwa nahone i khou lindela u sedzwa.",
        add_another_term: "Engedza ipfi ḽiṅwe",
        edit_this_term: "Lugisa ipfi ḽino",
        fuzziness_label: "Tshivhalo tsha u fana:",
        statuses_label: "Zwiimo:",
        merge_all_exact: "Vhambedza u fana hoṱhe ho fhelelaho ({{count}})",
        merge_all_exact_confirm: "Hezwi zwi ḓo vhambedza u fana ho fhelelaho ha {{count}}. Kha iṅwe na iṅwe, hu ḓo vulungwa iṅwe iṅwe i vhudzwe — hezwi a zwi koneli u shanduka. Bvela phanḓa?",
        merge_all_exact_done: "Ho vhambedzwa zwigwada zwa {{clusters}} zwa u fana ho fhelelaho ({{words}} zwo vhudzwa).",
        merging: "I khou vhambedza…",
        close: "Vala",
        request_needs_target_language: "U humbela u ṱalutshedzwa, nangani luambo lwo livhiswaho lwo khetheaho ni ṱole hafhu.",
        unverified: "A i athu khwaṱhisedzwa",
        notes: "Notsi",
        show_notes: "Sumbedzani notsi",
        hide_notes: "Dzumbani notsi",
        notes_hint: "Dzi vhonala fhedzi kha vhashumisi vho dzhenaho.",
      },
    },
    pt: {
      translation: {
        word: "Termo",
        update_term: "Prazo de atualização",
        source: "Idioma de origem",
        target: "Idioma alvo",
        partial: "Correspondência parcial",
        fuzzy: "Permitir erros de ortografia",
        enter: "Insira o termo de pesquisa",
        terminology: "Centro de Terminologia",
        alllanguages: "Todos os idiomas",
        search: "Procurar",
        language: "Linguagem",
        context: "Contexto",
        add: "Adicionar um novo termo",
        advanced: "Pesquisa avançada",
        accepted: "Aceito",
        pending: "Pendente",
        rejected: "Rejeitado",
        ACC: "Aceito",
        PND: "Pendente",
        REJ: "Rejeitado",
        status: "Status",
        translate_term: "Traduzir termo",
        sourceword: "Termo de origem",
        translatedterm: "Termo traduzido",
        example: "Exemplo",
        attribution: "Atribuição",
        newlanguage: "Novo idioma",
        definition: "Definição",
        school: "Escola",
        about: "Sobre nós",
        contact: "Contate-nos",
        user_manual: "Manual do usuário",
        addterm: "Adicionar termo",
        termdetail: "Detalhe do prazo",
        deleteconfirma: "Tem certeza de que deseja excluir '",
        deleteconfirmb: "'com contexto'",
        deleteconfirmc: "'na linguagem'",
        deleteconfirmd: "'?",
        yes: "Sim",
        no: "Não",
        back: "Voltar",
        translate: "Traduzir",
        update: "Atualizar",
        delete: "Excluir",
        save: "Guardar",
        cancel: "Cancelar",
        login: "Entrar",
        logout: "Sair",
        validation_word_required: "É necessária uma palavra.",
        validation_translation_required: "É necessário um termo traduzido.",
        something_went_wrong: "Ocorreu um problema.",
        english_translation: "Tradução em inglês:",
        search_term_required: "É necessário um termo de pesquisa.",
        login_failed: "Falha ao iniciar sessão!",
        generic_error: "Ocorreu um erro",
        could_not_download_template: "Não foi possível transferir o modelo.",
        could_not_download_file: "Não foi possível transferir o ficheiro.",
        could_not_run_report: "Não foi possível gerar o relatório.",
        could_not_delete_request: "Não foi possível eliminar a solicitação.",
        search_failed: "A pesquisa falhou.",
        delete_failed: "A eliminação falhou.",
        something_went_wrong_adding_term: "Ocorreu um problema ao adicionar o termo.",
        failed_to_add_term: "Não foi possível adicionar o termo.",
        something_went_wrong_fetching_terms: "Ocorreu um problema ao obter os termos.",
        registration_failed: "O registo falhou",
        confirmlogout: "Confirmar saída",
        register: "Registrar usuário",
        emailaddress: "Endereço de e-mail",
        typeagain: "Digite o endereço de e-mail novamente",
        surname: "Sobrenome",
        firstname: "Nome",
        username: "Nome de usuário",
        password: "Senha",
        message_username: "Nome de usuário já existe. Por favor, escolha outro.",
        message_email: "E-mail já registrado. Por favor, use outro e-mail.",
        message_valid: "O endereço de e-mail não é válido.",
        message_notsame: "Os endereços de e-mail não são os mesmos.",
        request_translation: "Solicitar tradução",
        submit_request: "Enviar solicitação",
        term_not_found: "Termo não encontrado",
        submitsuccess: "Solicitação enviada com sucesso!",
        theterm: "O termo ",
        notfound: " não foi encontrado.",
        liketorequest: "Você gostaria de solicitar uma tradução? ",
        suggest_translationa: "Você quer sugerir um termo possível em ",
        suggest_translationb: "?",
        ifsotype: "Se sim, digite aqui:",
        notranslation: "Nenhuma tradução foi encontrada.",
        add_request: "Adicionar termo solicitado",
        add_translation: "Adicionar tradução",
        delete_request: "Excluir solicitação",
        delete_request_confirm: "Excluir esta solicitação? Isto não pode ser desfeito.",
        suggested_translation: "Tradução sugerida",
        date_requested: "Data solicitada",
        action: "Ação",
        no_requests: "Nenhum pedido encontrado",
        r_user: "Usuário registado",
        editor: "Editor",
        date_edited_label: "Última edição:",
        delete_a: "Excluir A",
        delete_b: "Excluir B",
        delete_word_confirm: "Excluir '{{word}}'? Isto não pode ser desfeito.",
        administrator: "Administrador",
        requestlist: "Termos solicitados",
        word_to_be_added: 'Termo a ser adicionado',
        pos: "Parte do discurso",
        unknown: "Desconhecido",
        noun: "Substantivo",
        verb: "Verbo",
        adjective: "Adjetivo",
        pronoun: "Pronome",
        adverb: "Advérbio",
        preposition: "Preposição",
        conjunction: "Conjunção",
        interjection: "Interjeição",
        article: "Artigo",
        suggests: "sugere",
        wiktionary_lookup: "Consultar no Wiktionary",
        actions: "Ações",
        review_queue: "Fila de revisão",
        my_suggestions: "Minhas sugestões",
        missing_terms: "Termos em falta",
        duplicate_cleanup: "Limpeza de duplicados",
        english: "Inglês",
        submitted_by: "Enviado por",
        days_pending: "Dias pendentes",
        approve: "Aprovar",
        reject: "Rejeitar",
        flag_action: "Sinalizar",
        previous: "Anterior",
        next: "Seguinte",
        nothing_waiting_review: "Nada está à espera de revisão.",
        showing_range: "A mostrar {{start}}–{{end}} de {{total}}",
        you_havent_submitted: "Ainda não submeteu nenhum termo.",
        target_language: "Idioma de destino:",
        nothing_missing: "Nada está em falta para este idioma.",
        match_type: "Correspondência",
        word_a: "Palavra A",
        word_b: "Palavra B",
        english_reference_label: "Inglês (apenas para referência)",
        no_english_reference: "Nenhuma entrada de referência em inglês encontrada.",
        user_admin: "Administração de Usuários",
        approver: "Aprovador",
        role: "Função",
        change_role: "Alterar função",
        download_csv_template: "Baixar modelo CSV",
        upload_csv: "Enviar CSV",
        uploading: "Enviando...",
        upload_progress: "{{completed}} / {{total}} termo(s) processado(s)",
        upload_interrupted: "Envio interrompido após {{completed}} de {{total}} termo(s). Verifique os resultados e reenvie as linhas restantes, se necessário.",
        choose_csv_file: "Escolher arquivo CSV",
        bulk_upload_users: "Envio em massa de usuários",
        bulk_upload_help: "Envie um arquivo CSV para criar vários usuários de uma vez. Baixe o modelo abaixo primeiro para garantir que o arquivo esteja no formato correto.",
        temporary_password: "Senha temporária",
        temporary_password_notice: "Copie esta senha agora e compartilhe-a com o usuário — ela não será exibida novamente.",
        user_created: "Usuário '{{username}}' criado.",
        delete_user_confirm: "Excluir usuário '{{username}}'? Isto não pode ser desfeito.",
        csv_upload_results: "Resultados do envio",
        rows_created: "{{count}} usuário(s) criado(s)",
        terms_created: "{{count}} termo(s) adicionado(s)",
        duplicate_warning_title: "Possível importação duplicada",
        duplicate_warning_message: "Todos os {{count}} termo(s) neste arquivo já existem. Isso parece ser a mesma lista sendo importada novamente.",
        replace_previous_import: "Substituir importação anterior",
        add_in_any_case: "Adicionar mesmo assim",
        rows_skipped: "{{count}} linha(s) ignorada(s)",
        row_label: "Linha",
        error_label: "Erro",
        existing_users: "Usuários existentes",
        term_admin: "Administração de Termos",
        bulk_upload_terms: "Envio em massa de termos",
        bulk_upload_terms_help: "Envie um arquivo CSV para criar vários termos de uma vez, por exemplo a partir de uma lista preparada em outro lugar. Baixe o modelo abaixo primeiro para garantir que o arquivo esteja no formato correto.",
        export_terms: "Exportar termos",
        search_export_terms: "Pesquisar / exportar termos",
        export_terms_help: "Filtre os termos abaixo, depois pesquise para ver o que corresponde, exporte-os para CSV, ou exclua-os em massa.",
        export_csv: "Exportar CSV",
        exporting: "Exportando...",
        search_terms: "Pesquisar",
        searching: "Pesquisando...",
        no_matching_terms: "Nenhum termo correspondeu.",
        delete_matching_terms: "Excluir {{count}} termo(s) correspondente(s)",
        deleting: "Excluindo...",
        date_added: "Data de adição",
        date_last_edited: "Última edição",
        filter_date_created_from: "Adicionado a partir de:",
        filter_date_created_to: "Adicionado até:",
        filter_date_edited_from: "Última edição a partir de:",
        filter_date_edited_to: "Última edição até:",
        bulk_delete_modal_title: "Excluir termos correspondentes?",
        bulk_delete_modal_warning: "Isto excluirá permanentemente {{count}} termo(s) correspondente(s) aos filtros atuais. Isto não pode ser desfeito.",
        bulk_delete_confirm_label: "Digite {{count}} para confirmar",
        bulk_delete_confirm_button: "Excluir",
        reports_heading: "Relatórios",
        reports_help: "Veja quantos termos foram adicionados, agrupados por idioma e período.",
        report_period_label: "Agrupar por:",
        report_period_day: "Dia",
        report_period_week: "Semana",
        report_period_month: "Mês",
        run_report: "Gerar relatório",
        running_report: "Gerando relatório...",
        download_report_csv: "Baixar CSV",
        report_no_data: "Nenhum termo corresponde a estes filtros.",
        keep_a_merge_b: "Manter A, juntar B",
        keep_b_merge_a: "Manter B, juntar A",
        not_a_duplicate: "É duplicado não",
        no_duplicates_found: "Não foram encontrados duplicados ou conflitos.",
        filter_language: "Idioma:",
        filter_submitted_by: "Enviado por:",
        filter: "Filtrar",
        clear_filters: "Limpar filtros",
        all_languages_filter: "Todos os idiomas",
        term_added: "'{{word}}' foi adicionado e está agora pendente de revisão.",
        add_another_term: "Adicionar outro termo",
        edit_this_term: "Editar este termo",
        fuzziness_label: "Tolerância de correspondência:",
        statuses_label: "Estados:",
        merge_all_exact: "Fundir todas as correspondências exatas ({{count}})",
        merge_all_exact_confirm: "Isto irá fundir {{count}} correspondências exatas. Em cada uma, uma entrada será mantida e a outra eliminada — isto não pode ser desfeito. Continuar?",
        merge_all_exact_done: "Foram fundidos {{clusters}} grupos de duplicados exatos ({{words}} entradas eliminadas).",
        merging: "A fundir…",
        close: "Fechar",
        request_needs_target_language: "Para pedir uma tradução, escolha um idioma de destino específico e pesquise novamente.",
        unverified: "Não verificado",
        notes: "Notas",
        show_notes: "Mostrar notas",
        hide_notes: "Ocultar notas",
        notes_hint: "Visível apenas para utilizadores com sessão iniciada.",
      },
    },
    fr: {
      translation: {
        word: "Terme",
        update_term: "Terme de mise à jour",
        source: "Langue source",
        target: "Langue cible",
        partial: "Correspondance partielle",
        fuzzy: "Autoriser les fautes d'orthographe",
        enter: "Entrez le terme de recherche",
        terminology: "Centre de terminologie",
        alllanguages: "Toutes les langues",
        search: "Recherche",
        language: "Langue",
        context: "Contexte",
        add: "Ajouter un nouveau terme",
        advanced: "Recherche avancée",
        accepted: "Accepté",
        pending: "En attente",
        rejected: "Rejeté",
        ACC: "Accepté",
        PND: "En attente",
        REJ: "Rejeté",
        status: "Statut",
        translate_term: "Traduire le terme",
        sourceword: "Terme source",
        translatedterm: "Terme traduit",
        example: "Exemple",
        attribution: "Attribution",
        newlanguage: "Nouvelle langue",
        definition: "Définition",
        school: "École",
        about: "À propos de nous",
        contact: "Contactez-nous",
        user_manual: "Manuel de l'utilisateur",
        addterm: "Ajouter un terme",
        termdetail: "Détail du terme",
        deleteconfirma: "Etes-vous sûr de vouloir supprimer '",
        deleteconfirmb: "'avec contexte'",
        deleteconfirmc: "'dans la langue'",
        deleteconfirmd: "'?",
        yes: "Oui",
        no: "Non",
        back: "Dos",
        translate: "Traduire",
        update: "Mise à jour",
        delete: "Supprimer",
        save: "Enregistrer",
        cancel: "Annuler",
        login: "Se connecter",
        logout: "Se déconnecter",
        validation_word_required: "Un mot est requis.",
        validation_translation_required: "Un terme traduit est requis.",
        something_went_wrong: "Un problème est survenu.",
        english_translation: "Traduction anglaise :",
        search_term_required: "Un terme de recherche est requis.",
        login_failed: "Échec de la connexion !",
        generic_error: "Une erreur s'est produite",
        could_not_download_template: "Impossible de télécharger le modèle.",
        could_not_download_file: "Impossible de télécharger le fichier.",
        could_not_run_report: "Impossible de générer le rapport.",
        could_not_delete_request: "Impossible de supprimer la demande.",
        search_failed: "Échec de la recherche.",
        delete_failed: "Échec de la suppression.",
        something_went_wrong_adding_term: "Un problème est survenu lors de l'ajout du terme.",
        failed_to_add_term: "Impossible d'ajouter le terme.",
        something_went_wrong_fetching_terms: "Un problème est survenu lors de la récupération des termes.",
        registration_failed: "Échec de l'inscription",
        confirmlogout: "Confirmer la déconnexion",
        register: "S'inscrire",
        emailaddress: "Adresse e-mail",
        typeagain: "Ressaisissez l'adresse e-mail",
        surname: "Nom de famille",
        firstname: "Prénom",
        username: "Nom d'utilisateur",
        password: "Mot de passe",
        message_username: "Le nom d'utilisateur existe déjà. Veuillez en choisir un autre.",
        message_email: "L'e-mail est déjà enregistré. Veuillez utiliser un autre e-mail.",
        message_valid: "L'adresse e-mail n'est pas valide.",
        message_notsame: "Les adresses e-mail ne sont pas les mêmes.",
        request_translation: "Demander une traduction",
        submit_request: "Soumettre la demande",
        term_not_found: "Terme non trouvé",
        submitsuccess: "Demande soumise avec succès!",
        theterm: "Le terme ",
        notfound: " n'a pas été trouvé.",
        liketorequest: "Voulez-vous demander une traduction? ",
        suggest_translationa: "Voulez-vous suggérer un terme possible en ",
        suggest_translationb: "?",
        ifsotype: "Si oui, tapez-le ici:",
        notranslation: "Aucune traduction trouvée.",
        add_request: "Ajouter le terme demandé",
        add_translation: "Ajouter une traduction",
        delete_request: "Supprimer la demande",
        delete_request_confirm: "Supprimer cette demande ? Cette action est irréversible.",
        suggested_translation: "Traduction suggérée",
        date_requested: "Date demandée",
        action: "Action",
        no_requests: "Aucune demande trouvée",
        r_user: "Utilisateur inscrit",
        editor: "Éditeur",
        date_edited_label: "Dernière modification :",
        delete_a: "Supprimer A",
        delete_b: "Supprimer B",
        delete_word_confirm: "Supprimer « {{word}} » ? Cette action est irréversible.",
        administrator: "Administrateur",
        requestlist: "Termes demandés",
        word_to_be_added: 'Terme à ajouter',
        pos: "Partie du discours",
        unknown: "Inconnu",
        noun: "Nom",
        verb: "Verbe",
        adjective: "Adjectif",
        pronoun: "Pronom",
        adverb: "Adverbe",
        preposition: "Préposition",
        conjunction: "Conjonction",
        interjection: "Interjection",
        article: "Article",
        suggests: "suggère",
        wiktionary_lookup: "Consulter sur Wiktionary",
        actions: "Actions",
        review_queue: "File de révision",
        my_suggestions: "Mes suggestions",
        missing_terms: "Termes manquants",
        duplicate_cleanup: "Nettoyage des doublons",
        english: "Anglais",
        submitted_by: "Soumis par",
        days_pending: "Jours en attente",
        approve: "Approuver",
        reject: "Rejeter",
        flag_action: "Signaler",
        previous: "Précédent",
        next: "Suivant",
        nothing_waiting_review: "Rien n'attend de révision.",
        showing_range: "Affichage de {{start}}–{{end}} sur {{total}}",
        you_havent_submitted: "Vous n'avez encore soumis aucun terme.",
        target_language: "Langue cible :",
        nothing_missing: "Rien ne manque pour cette langue.",
        match_type: "Correspondance",
        word_a: "Mot A",
        word_b: "Mot B",
        english_reference_label: "Anglais (à titre de référence uniquement)",
        no_english_reference: "Aucune entrée de référence en anglais trouvée.",
        user_admin: "Administration des utilisateurs",
        approver: "Approbateur",
        role: "Rôle",
        change_role: "Changer le rôle",
        download_csv_template: "Télécharger le modèle CSV",
        upload_csv: "Importer le CSV",
        uploading: "Importation...",
        upload_progress: "{{completed}} / {{total}} terme(s) traité(s)",
        upload_interrupted: "Importation interrompue après {{completed}} sur {{total}} terme(s). Veuillez vérifier les résultats et réimporter les lignes restantes si nécessaire.",
        choose_csv_file: "Choisir un fichier CSV",
        bulk_upload_users: "Importation groupée d'utilisateurs",
        bulk_upload_help: "Importez un fichier CSV pour créer plusieurs utilisateurs à la fois. Téléchargez d'abord le modèle ci-dessous pour vous assurer que le fichier est au bon format.",
        temporary_password: "Mot de passe temporaire",
        temporary_password_notice: "Copiez ce mot de passe maintenant et communiquez-le à l'utilisateur — il ne sera plus affiché ensuite.",
        user_created: "Utilisateur « {{username}} » créé.",
        delete_user_confirm: "Supprimer l'utilisateur « {{username}} » ? Cette action est irréversible.",
        csv_upload_results: "Résultats de l'importation",
        rows_created: "{{count}} utilisateur(s) créé(s)",
        terms_created: "{{count}} terme(s) ajouté(s)",
        duplicate_warning_title: "Importation potentiellement en double",
        duplicate_warning_message: "Les {{count}} terme(s) de ce fichier existent déjà tous. Il semble que la même liste soit importée à nouveau.",
        replace_previous_import: "Remplacer l'importation précédente",
        add_in_any_case: "Ajouter quand même",
        rows_skipped: "{{count}} ligne(s) ignorée(s)",
        row_label: "Ligne",
        error_label: "Erreur",
        existing_users: "Utilisateurs existants",
        term_admin: "Administration des termes",
        bulk_upload_terms: "Importation groupée de termes",
        bulk_upload_terms_help: "Importez un fichier CSV pour créer plusieurs termes à la fois, par exemple à partir d'une liste préparée ailleurs. Téléchargez d'abord le modèle ci-dessous pour vous assurer que le fichier est au bon format.",
        export_terms: "Exporter les termes",
        search_export_terms: "Rechercher / exporter les termes",
        export_terms_help: "Filtrez les termes ci-dessous, puis recherchez pour voir ce qui correspond, exportez-les en CSV, ou supprimez-les en masse.",
        export_csv: "Exporter en CSV",
        exporting: "Exportation...",
        search_terms: "Rechercher",
        searching: "Recherche...",
        no_matching_terms: "Aucun terme ne correspond.",
        delete_matching_terms: "Supprimer {{count}} terme(s) correspondant(s)",
        deleting: "Suppression...",
        date_added: "Date d'ajout",
        date_last_edited: "Dernière modification",
        filter_date_created_from: "Ajouté à partir du :",
        filter_date_created_to: "Ajouté jusqu'au :",
        filter_date_edited_from: "Dernière modification à partir du :",
        filter_date_edited_to: "Dernière modification jusqu'au :",
        bulk_delete_modal_title: "Supprimer les termes correspondants ?",
        bulk_delete_modal_warning: "Cela supprimera définitivement {{count}} terme(s) correspondant à vos filtres actuels. Cette action est irréversible.",
        bulk_delete_confirm_label: "Tapez {{count}} pour confirmer",
        bulk_delete_confirm_button: "Supprimer",
        reports_heading: "Rapports",
        reports_help: "Consultez le nombre de termes ajoutés, regroupés par langue et par période.",
        report_period_label: "Regrouper par :",
        report_period_day: "Jour",
        report_period_week: "Semaine",
        report_period_month: "Mois",
        run_report: "Générer le rapport",
        running_report: "Génération du rapport...",
        download_report_csv: "Télécharger le CSV",
        report_no_data: "Aucun terme ne correspond à ces filtres.",
        keep_a_merge_b: "Garder A, fusionner B",
        keep_b_merge_a: "Garder B, fusionner A",
        not_a_duplicate: "Pas un doublon",
        no_duplicates_found: "Aucun doublon ni conflit trouvé.",
        filter_language: "Langue :",
        filter_submitted_by: "Soumis par :",
        filter: "Filtrer",
        clear_filters: "Effacer les filtres",
        all_languages_filter: "Toutes les langues",
        term_added: "« {{word}} » a été ajouté et est maintenant en attente de révision.",
        add_another_term: "Ajouter un autre terme",
        edit_this_term: "Modifier ce terme",
        fuzziness_label: "Tolérance de correspondance :",
        statuses_label: "Statuts :",
        merge_all_exact: "Fusionner toutes les correspondances exactes ({{count}})",
        merge_all_exact_confirm: "Cela fusionnera {{count}} correspondances exactes. Pour chacune, une entrée sera conservée et l'autre supprimée — cette action est irréversible. Continuer ?",
        merge_all_exact_done: "{{clusters}} groupes de doublons exacts fusionnés ({{words}} entrées supprimées).",
        merging: "Fusion en cours…",
        close: "Fermer",
        request_needs_target_language: "Pour demander une traduction, choisissez une langue cible précise et relancez la recherche.",
        unverified: "Non vérifié",
        notes: "Notes",
        show_notes: "Afficher les notes",
        hide_notes: "Masquer les notes",
        notes_hint: "Visible uniquement par les utilisateurs connectés.",
      },
    },
  },
});

export default i18n;
